export const es = {
  nav: {
    overview: "Resumen",
    accounts: "Cuentas",
    payouts: "Pagos",
    affiliate: "Affiliate",
    support: "Soporte"
  },
  dashboardheader: {
    serverTime: "Hora del Servidor",
    wallet: "Wallet",
    settings: "Configuracion",
    logout: "Cerrar Sesion",
    goToProfile: "Ir al Perfil"
  },
  protectedLayout: {
    connecting: {
      title: "Estableciendo Conexion",
      authenticating: "Autenticando...",
      establishing: "Estableciendo conexion..."
    },
    connectionLost: {
      title: "Sin Conexion al Servidor",
      description: "La conexion ha sido interrumpida. Estamos intentando restaurar la conexion automaticamente.",
      possibleCauses: "Posibles Causas:",
      causes: {
        internet: "Tu conexion a internet fue interrumpida",
        maintenance: "El servidor esta actualmente en mantenimiento",
        firewall: "Tu firewall o proxy esta bloqueando la conexion",
        sleep: "Tu dispositivo entro en modo de suspension"
      },
      reconnecting: "Reconectando...",
      attempt: "Intento",
      waiting: "Esperando conexion...",
      reloadButton: "Recargar Pagina Manualmente"
    },
    connectionRestored: {
      title: "Conexion Restaurada",
      message: "Conectado al servidor"
    }
  },
  accountCards: {
    title: "Cuentas de Trading",
    addAccount: "Agregar Cuenta",
    selectMultiple: "Seleccionar Varias",
    cancelSelection: "Cancelar",
    backToAccounts: "Volver a Cuentas",
    balance: "Saldo",
    days: "Dias de Trading",
    maxLots: "Max Lots",
    drawdown: "Drawdown",
    finalPnL: "P&L Final",
    current: "Actual",
    target: "Objetivo",
    evaluationFailed: "Evaluacion Fallida",
    evaluationPassed: "Evaluacion Aprobada",
    evaluationPassedTitle: "Felicidades!",
    congratulationsSuccess: "Has aprobado tu evaluacion exitosamente",
    resetAccount: "Reiniciar Cuenta",
    extendAccount: "Extender Cuenta",
    signFundedAgreement: "Activa tu nueva Cuenta Financiada",
    awaitingFundedFee: "Esperando Cuota Funded",
    payFundedFee: "Pagar Cuota Funded",
    contractSigned: "Contrato firmado - pago requerido",
    livePnL: "P&L en Vivo",
    today: "hoy",
    since: "Desde: ",
    started: "Iniciado: ",
    passed: "Aprobado: ",
    failed: "Fallido: ",
    expired: "Expirado: ",
    open: "Abierta",
    accountExpired: "Cuenta Expirada",
    timeExpired: "Tiempo Expirado",
    accountPeriodEnded: "El periodo de la cuenta ha finalizado",
    daysUntilClosure: "Te quedan solo {{days}} dias para extender la cuenta, de lo contrario sera cerrada.",
    deactivationReasons: {
      "Rule Violation": "Violacion de Reglas"
    },
    ruleViolations: {
      "Max Drawdown exceeded": "Drawdown Maximo Excedido",
      "Trading outside permitted hours": "Trading Fuera del Horario Permitido",
      "Traded more contracts than permitted": "Se Negociaron Mas Contratos de los Permitidos"
    },
    expiryWarning: "Cuenta Proxima a Expirar",
    expiresIn: "La cuenta expira en {{days}} dia(s)",
    noAccountsTitle: "Aun no tienes cuentas de trading",
    noAccountsDescription: "Comienza comprando tu primera cuenta de evaluacion e inicia tu camino para convertirte en un trader financiado",
    fastSetup: "Configuracion Rapida",
    instantAccess: "Acceso Instantaneo",
    noHiddenFees: "Sin Costos Ocultos",
    status: {
      active: "Activa",
      inProgress: "Evaluacion",
      passed: "Aprobada",
      failed: "Fallida",
      expired: "Expirada"
    },
    filters: {
      all: "Todas",
      funded: "Funded",
      evaluation: "Evaluacion",
      active: "Activas",
      inactive: "Inactivas",
      resettable: "Reiniciables",
      expired: "Expiradas",
      noResults: "Ninguna cuenta coincide con este filtro",
      showAll: "Mostrar todas las cuentas"
    }
  },
  accountInformation: {
    title: "Informacion de la Cuenta",
    accountTimeline: "Cronologia de la Cuenta",
    accountSize: "Tamano de la Cuenta",
    dataFeed: "Fuente de Datos",
    loginCredentials: "Credenciales de Acceso",
    username: "Usuario",
    password: "Contrasena",
    server: "Servidor",
    copy: "Copiar",
    important: "Importante",
    credentialsNote: "Usa estas credenciales para iniciar sesion en tu plataforma {dataFeed}. Mantenlas seguras y no las compartas con nadie.",
    startDate: "Fecha de Inicio",
    expiryDate: "Fecha de Expiracion",
    daysRemaining: "Dias Restantes",
    days: "dias",
    extend: "Extender",
    extendAccount: "Extender Cuenta",
    resetBalance: "Reset",
    tradingSpecifications: "Especificaciones de Trading",
    maxPositionSize: "Max Lots",
    profitTarget: "Objetivo de Ganancia",
    maxDrawdown: "Drawdown Maximo",
    tradingHours: "Horario de Trading",
    accountPeriodEnded: "El periodo de la cuenta ha finalizado"
  },
  accountSelector: {
    title: "Analitica de la Cuenta",
    analytics: "Analitica en Vivo",
    description: "Seguimiento de rendimiento en tiempo real",
    liveData: "Datos en Vivo",
    account: "Cuenta",
    status: "Estado"
  },
  performanceMetrics: {
    accountBalance: "Saldo de la Cuenta",
    netProfit: "Ganancia Neta",
    todaysPnL: "P&L de Hoy",
    winRate: "Tasa de Acierto",
    tradingDays: "Dias de Trading",
    vsYesterday: "vs ayer",
    trades: "Operaciones",
    totalExecuted: "Total ejecutadas",
    activeDays: "Dias activos",
    allTime: "Todo el tiempo"
  },
  performanceChart: {
    title: "Grafico de Rendimiento",
    subtitle: "Saldo de la cuenta a lo largo del tiempo",
    balance: "Saldo",
    pnl: "P&L",
    percentage: "Porcentaje",
    currentBalance: "Saldo Actual",
    drawdownLimit: "Limite de Drawdown",
    profitFactor: "Factor de Ganancia",
    avgWinLoss: "Promedio Ganancia/Perdida",
    target: "Objetivo",
    unlimited: "Ilimitado",
    limit: "Limite",
    start: "Inicio",
    hoverForDetails: "Pasa el cursor sobre los puntos del grafico para ver detalles"
  },
  pnlBreakdown: {
    title: "Desglose de P&L",
    subtitle: "Analisis de ganancias y perdidas",
    bySymbol: "Por Simbolo",
    byTime: "Por Tiempo",
    grossProfit: "Ganancia Bruta",
    grossLoss: "Perdida Bruta",
    netPnL: "P&L Neto",
    byTradingSymbol: "Por Simbolo de Trading",
    byTimeOfDay: "Por Hora del Dia",
    noData: "No hay datos de trading disponibles"
  },
  riskAnalysis: {
    title: "Analisis de Riesgo",
    subtitle: "Metricas de riesgo de la cuenta"
  },
  tradeHistory: {
    title: "Historial de Operaciones",
    tradesFound: "operaciones encontradas",
    export: "Exportar",
    allTrades: "Todas las Operaciones",
    winsOnly: "Solo Ganadoras",
    lossesOnly: "Solo Perdedoras",
    searchPlaceholder: "Buscar por simbolo...",
    symbol: "Simbolo",
    type: "Tipo",
    entry: "Entrada",
    exit: "Salida",
    qty: "Cant.",
    pnl: "P&L",
    duration: "Duracion",
    entryDateTime: "Fecha/Hora de Entrada",
    exitDateTime: "Fecha/Hora de Salida",
    showing: "Mostrando",
    of: "de",
    trades: "operaciones",
    previous: "Anterior",
    next: "Siguiente",
    winningTrades: "Operaciones Ganadoras",
    losingTrades: "Operaciones Perdedoras",
    totalPnL: "P&L Total",
    winRate: "Tasa de Acierto",
    noTradesFound: "No se encontraron operaciones"
  },
  tradingStatistics: {
    title: "Estadisticas de Trading",
    subtitle: "Metricas de rendimiento detalladas",
    winRate: "Tasa de Acierto",
    winningTrades: "Operaciones Ganadoras",
    losingTrades: "Operaciones Perdedoras",
    averagePerformance: "Rendimiento Promedio",
    avgWin: "Ganancia Prom.",
    avgLoss: "Perdida Prom.",
    profitFactor: "Factor de Ganancia",
    extremes: "Extremos",
    largestWin: "Mayor Ganancia",
    largestLoss: "Mayor Perdida",
    bestDay: "Mejor Dia",
    worstDay: "Peor Dia",
    streaks: "Rachas",
    maxWinningStreak: "Racha Maxima de Ganancias",
    maxLosingStreak: "Racha Maxima de Perdidas",
    avgTradeDuration: "Duracion Prom. de Operacion",
    trades: "operaciones"
  },
  affiliate: {
    title: "Programa de Affiliate",
    referralSystem: "Sistema de Referidos",
    earnCommissions: "Gana comisiones refiriendo traders",
    tier: "Nivel",
    silver: "Plata",
    gold: "Oro",
    bonus: "Bono",
    handleChangedToast: "Tu identificador de affiliate ha sido cambiado. Tus enlaces de referido han sido actualizados automaticamente. Por favor verifica si algun enlace de marketing compartido anteriormente necesita ser reemplazado.",
    errorTitle: "No se pudieron cargar los datos de afiliado",
    errorSubtitle: "Algo salio mal",
    errorDescription: "No pudimos cargar tu informacion de afiliado. Esto puede ocurrir si tu cuenta de afiliado aun no ha sido configurada o si hubo un problema de conexion temporal.",
    retry: "Reintentar",
    backToDashboard: "Volver al Dashboard",
    createAffiliate: "Crear Afiliado",
    creating: "Creando...",
    enrollFailed: "No se pudo crear la cuenta de afiliado. Por favor, intentalo de nuevo."
  },
  affiliateOverview: {
    totalEarnings: "Ganancias Totales",
    activeReferrals: "Referidos Activos",
    conversionRate: "Tasa de Conversion",
    totalCommissions: "Comisiones Totales",
    commissionRate: "Tasa de Comision",
    thisMonth: "este mes",
    standard: "Estandar",
    onAllSales: "en todas las ventas",
    vsLastMonth: "vs mes anterior"
  },
  affiliateTier: {
    tier: "Nivel",
    progressTo: "Progreso hacia",
    currentAffiliate: "Nivel Actual de Affiliate",
    currentBenefits: "Beneficios Actuales",
    progressToTier: "Progreso hacia Nivel",
    current: "Actual",
    allAffiliateTiers: "Todos los Niveles de Affiliate",
    revenue: "ingresos",
    nextTierUnlock: "Desbloqueo del siguiente nivel",
    moreRevenueNeeded: "mas ingresos necesarios",
    achieved: "Logrado"
  },
  affiliateStatistics: {
    title: "Estadisticas de Affiliate",
    weeklyEarningsOverview: "Resumen de ganancias semanales",
    day: "Dia",
    week: "Semana",
    month: "Mes",
    year: "Ano",
    currentMonth: "Mes Actual",
    currentQuarter: "Trimestre Actual",
    currentYear: "Ano Actual",
    last5Years: "Ultimos 5 Anos",
    previousMonth: "Mes Anterior",
    previousQuarter: "Trimestre Anterior",
    previousYear: "Ano Anterior",
    nextMonth: "Mes Siguiente",
    nextQuarter: "Trimestre Siguiente",
    nextYear: "Ano Siguiente",
    monthsAgo: "meses atras",
    monthsAhead: "meses adelante",
    quartersAgo: "trimestres atras",
    quartersAhead: "trimestres adelante",
    yearsAgo: "anos atras",
    yearsAhead: "anos adelante",
    totalEarningsLabel: "Ganancias Totales",
    lastWeeks: "ultimas 12 semanas",
    bestDayLabel: "Mejor Dia",
    bestWeekLabel: "Mejor Semana",
    bestMonthLabel: "Mejor Mes",
    bestYearLabel: "Mejor Ano",
    bestWeek: "Mejor semana",
    noData: "Sin datos",
    referrals: "referidos",
    avg: "prom",
    hoverForDetails: "Pasa el cursor sobre los puntos del grafico para ver detalles"
  },
  commissionTracking: {
    title: "Seguimiento de Comisiones",
    found: "comisiones encontradas",
    all: "Todas",
    paid: "Pagadas",
    pending: "Pendientes",
    posted: "Registradas",
    canceled: "Canceladas",
    searchPlaceholder: "Buscar comisiones...",
    commissionId: "ID de Comision",
    customer: "Cliente",
    plan: "Plan",
    commission: "Comision",
    status: "Estado",
    source: "Fuente",
    purchaseDate: "Fecha de Compra",
    paidDate: "Fecha de Pago",
    rate: "tasa",
    showing: "Mostrando",
    of: "de",
    commissions: "comisiones",
    previous: "Anterior",
    next: "Siguiente",
    totalCommission: "Comision Total",
    avgCommission: "Comision Prom.",
    onHoldUntil: "En espera hasta",
    postedAt: "Registrada el",
    canceledAt: "Cancelada el",
    reason: "Razon",
    sourceDetails: "Detalles de la Fuente",
    category: "Categoria",
    code: "Codigo",
    path: "Ruta",
    noCommissions: "No se encontraron comisiones",
    noCommissionsDescription: "No hay registros de comisiones que coincidan con tus filtros"
  },
  earningsOverview: {
    title: "Resumen de Ganancias",
    subtitle: "Tu rendimiento como affiliate",
    month: "Mes",
    quarter: "Trimestre",
    year: "Ano",
    totalEarnings: "Ganancias Totales",
    pending: "De las cuales pendientes",
    performanceMetrics: "Metricas de Rendimiento",
    conversionRate: "Tasa de Conversion",
    avgCommission: "Comision Prom.",
    transactions: "Transacciones",
    totalClicks: "Clics Totales",
    totalConversions: "Conversiones Totales",
    monthlyProgress: "Progreso Mensual",
    quarterlyProgress: "Progreso Trimestral",
    yearlyProgress: "Progreso Anual",
    allTimeProgress: "Progreso Total",
    goalProgress: "Progreso del Objetivo",
    goal: "Objetivo",
    all: "Todo"
  },
  marketingMaterials: {
    title: "Materiales de Marketing",
    subtitle: "Recursos profesionales para promocion",
    banners: "Banners",
    content: "Contenido",
    logos: "Logos",
    availableAssets: "Recursos Disponibles",
    quality: "Calidad",
    preview: "Vista Previa"
  },
  partnerLandingPage: {
    title: "Pagina de Socio",
    subtitle: "Tu pagina de referido personalizada",
    landingPageUrl: "URL de la Pagina",
    copyLink: "Copiar Enlace",
    partnerName: "Nombre del Socio",
    editText: "Editar Texto",
    enterPartnerName: "Ingresa el nombre del socio",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando...",
    landingPageStats: "Estadisticas de la Pagina",
    totalVisits: "Visitas Totales",
    conversions: "Conversiones",
    conversionRate: "Tasa de Conversion",
    revenue: "Ingresos",
    commission: "Comision"
  },
  payoutReports: {
    title: "Reportes de Pagos",
    subtitle: "Reportes mensuales de comisiones y pagos de wallet",
    all: "Todos",
    paid: "Pagados",
    pending: "Pendientes",
    completed: "Completados",
    rejected: "Rechazados",
    canceled: "Cancelados",
    totalPaid: "Total Pagado",
    totalReferrals: "Referidos Totales",
    reports: "Reportes",
    referrals: "referidos",
    paidToWallet: "Pagado a Wallet",
    paidOn: "Pagado el",
    pendingTooltip: "Se pagara al final del mes",
    walletPendingTooltip: "La solicitud de pago esta siendo procesada",
    walletCompletedTooltip: "El pago ha sido completado",
    walletRejectedTooltip: "El pago fue rechazado",
    walletCanceledTooltip: "El pago fue cancelado",
    rejectionReason: "Razon",
    walletPayout: "Pago de Wallet Affiliate",
    settlementReport: "Liquidacion de Comisiones",
    noReceiptAvailable: "No hay recibo disponible para este pago",
    showing: "Mostrando",
    of: "de",
    nextPayout: "Proximo Pago",
    exportAllReports: "Exportar Todos los Reportes",
    noFileAvailable: "No hay archivo disponible para esta liquidacion",
    downloadFailed: "Descarga fallida. Por favor intenta de nuevo.",
    noReports: "Aun no hay reportes de pagos disponibles",
    adjustFilters: "Intenta ajustar tus filtros"
  },
  referralLinks: {
    title: "Enlaces y Codigos de Referido",
    subtitle: "Administra tus enlaces y codigos de referido",
    tabLinks: "Enlaces",
    tabCodes: "Codigos",
    createCustomReferralLink: "Crear Enlace de Referido Personalizado",
    createCustomReferralCode: "Crear Codigo de Referido Personalizado",
    linkName: "Nombre del Enlace",
    codeName: "Nombre del Codigo",
    linkNamePlaceholder: "ej., Especial YouTube",
    codeNamePlaceholder: "ej., YOUTUBE2025",
    description: "Descripcion",
    descriptionPlaceholder: "ej., Enlace especial para contenido de YouTube",
    codeDescriptionPlaceholder: "ej., Codigo especial para espectadores de YouTube",
    category: "Categoria",
    categoryPlaceholder: "ej., YouTube, Instagram, etc.",
    customSlug: "Slug Personalizado (Opcional)",
    customSlugPlaceholder: "tu-url",
    customCode: "Codigo Personalizado",
    customCodePlaceholder: "MICODIGO2025",
    leaveEmptyNote: "Dejar vacio para generar automaticamente",
    leaveEmptyCodeNote: "Dejar vacio para generar codigo automaticamente",
    cancel: "Cancelar",
    createLink: "Crear Enlace",
    createCode: "Crear Codigo",
    clicks: "Clics",
    uses: "Usos",
    conversions: "Conversiones",
    rate: "Tasa",
    showing: "Mostrando",
    of: "de",
    links: "enlaces",
    codes: "codigos",
    previous: "Anterior",
    next: "Siguiente",
    page: "Pagina",
    createCustomLink: "Crear Enlace Personalizado",
    createCustomCode: "Crear Codigo Personalizado",
    noLinks: "Aun no hay enlaces de referido",
    noCodes: "Aun no hay codigos de referido",
    defaultCodeName: "Estandar",
    defaultCodeCategory: "Global",
    defaultCodeDescription: "Codigo generado por el sistema con 10% de descuento"
  },
  trafficSources: {
    title: "Fuentes de Trafico",
    subtitle: "De donde proviene tu trafico",
    clicks: "clics",
    rate: "tasa",
    uses: "usos",
    transactions: "transacciones",
    noLinksYet: "Aun no hay fuentes de trafico de enlaces disponibles",
    noCodesYet: "Aun no hay fuentes de trafico de codigos disponibles",
    showing: "Mostrando",
    of: "de",
    sources: "fuentes",
    previous: "Anterior",
    next: "Siguiente",
    summary: "Resumen",
    totalClicks: "Clics Totales",
    totalUses: "Usos Totales",
    conversions: "Conversiones",
    totalCommission: "Comision Total",
    avgRate: "Tasa Prom."
  },
  walletModal: {
    title: "Wallet",
    subtitle: "Administra tus fondos",
    overview: "Resumen",
    transactions: "Transacciones"
  },
  walletBalance: {
    title: "Saldo de Wallet",
    available: "Fondos disponibles",
    today: "hoy"
  },
  balanceBreakdown: {
    title: "Desglose del Saldo",
    affiliateCommissions: "Comisiones de Affiliate",
    affiliateDesc: "Ganancias por referidos",
    rewards: "Recompensas",
    rewardsDesc: "Ganancias de bonos",
    crediting: "Acreditacion",
    creditingDesc: "Creditos de cuenta",
    processing: "Procesando...",
    payout: "Pago",
    creditsNote: "Los creditos y recompensas se agregan automaticamente a tu saldo y pueden usarse para todas las compras, pero no pueden ser retirados."
  },
  transactionHistory: {
    title: "Historial de Transacciones",
    recentActivity: "Actividad Reciente",
    viewAll: "Ver Todo",
    showing: "Mostrando",
    of: "de",
    transactions: "transacciones"
  },
  payoutTab: {
    availableForPayout: "Disponible para Retiro",
    affiliateCommissionBalance: "Saldo de Comisiones de Affiliate",
    bankTransfer: "Transferencia Bancaria",
    paypal: "PayPal",
    cryptocurrency: "Criptomoneda",
    requestAffiliatePayout: "Solicitar Retiro de Affiliate",
    withdrawCommissionEarnings: "Retira tus ganancias de comisiones",
    selectPaymentMethod: "Seleccionar Metodo de Pago",
    payoutSummary: "Resumen del Pago",
    requestedAmount: "Monto Solicitado",
    processingFee: "Comision de Procesamiento",
    netAmount: "Monto Neto",
    processingRequest: "Procesando Solicitud...",
    importantNotes: "Notas Importantes",
    note1: "Los pagos de affiliate se procesan en 1-2 dias habiles",
    note2: "El monto minimo de retiro es de 50 EUR para todos los metodos de pago",
    note3: "Las comisiones de procesamiento varian segun el metodo de pago",
    payoutRequestSubmitted: "Solicitud de Pago Enviada!",
    payoutRequestSuccess: "Tu solicitud de pago por ${amount} ha sido enviada exitosamente.",
    affiliateCommissions: "Comisiones de Affiliate",
    readyForWithdrawal: "Listo para retiro",
    bankTransferDesc: "Transferencia directa a tu cuenta bancaria",
    free: "Gratis",
    paypalDesc: "Pago rapido via PayPal",
    cryptocurrencyDesc: "Pago via criptomoneda",
    account: "Cuenta",
    amount: "Monto",
    method: "Metodo",
    destination: "Destino",
    processingTime: "Tiempo de Procesamiento",
    businessDays: "1-3 dias habiles",
    fee: "Comision",
    managePayouts: "Administrar Metodos"
  },
  payouts: {
    title: "Pagos",
    management: "Gestion de Pagos",
    description: "Solicita y rastrea tus pagos",
    available: "Disponible"
  },
  payoutStats: {
    availableBalance: "Saldo Disponible",
    totalPaidOut: "Total Pagado",
    thisMonth: "Este Mes",
    nextPayout: "Proximo Pago",
    pendingPayouts: "Pagos Pendientes",
    pending: "Pendiente",
    today: "Hoy",
    payouts: "pagos",
    allTime: "Todo el Tiempo",
    january2025: "Enero 2025",
    tomorrow: "Manana",
    dailySchedule: "Programacion Diaria",
    automatic: "Automatico"
  },
  payoutRequest: {
    title: "Solicitar Pago",
    subtitle: "Retira tus ganancias de trading",
    selectAccount: "Seleccionar Cuenta",
    availableBalance: "Saldo Disponible",
    payoutAmount: "Monto del Pago",
    minAmount: "Monto minimo",
    amountError: "El monto debe estar entre {min} y {max}",
    insufficientBalance: "Tu saldo disponible esta por debajo del monto minimo de retiro de {min}",
    selectAccountFirst: "Por favor selecciona una cuenta primero",
    paymentMethod: "Metodo de Pago",
    selectYour: "Selecciona tu",
    bankTransfer: "Transferencia Bancaria",
    paypal: "PayPal",
    crypto: "Criptomoneda",
    ach: "Transferencia ACH",
    bankTransferDesc: "Transferencia bancaria (1-3 dias habiles)",
    paypalDesc: "Transferencia PayPal (instantanea)",
    cryptoDesc: "Transferencia de criptomoneda (instantanea)",
    achDesc: "Transferencia bancaria via ACH (1-3 dias habiles)",
    fee: "Comision",
    free: "Gratis",
    payoutSummary: "Resumen del Pago",
    requestedAmount: "Monto Solicitado",
    processingFee: "Comision de Procesamiento",
    netAmount: "Monto Neto",
    submitRequest: "Enviar Solicitud de Pago",
    processing: "Procesando...",
    importantNotes: "Notas Importantes",
    note1: "Los pagos se procesan en 1-3 dias habiles",
    note2: "El monto minimo de retiro es de $50",
    note3: "Solo puedes solicitar pagos de cuentas financiadas",
    available: "Disponible",
    payoutRequestSubmitted: "Solicitud de Pago Enviada!",
    payoutRequestSuccess: "Tu solicitud de pago por ${amount} ha sido enviada exitosamente.",
    account: "Cuenta",
    amount: "Monto",
    method: "Metodo",
    destination: "Destino",
    processingTime: "Tiempo de Procesamiento",
    businessDays: "1-3 dias habiles",
    noFundedAccountsTitle: "No Hay Cuentas Financiadas Disponibles",
    noFundedAccountsDesc: "No tienes cuentas financiadas con saldo disponible para retiro en este momento.",
    noAffiliateBalanceTitle: "No Hay Saldo de Affiliate Disponible",
    noAffiliateBalanceDesc: "No tienes saldo de comisiones de affiliate disponible para retiro en este momento.",
    selectCurrency: "Seleccionar Moneda",
    currency: "Moneda",
    noMethodsConfigured: "No hay metodos de {method} configurados. Por favor agrega uno en Metodos de Pago.",
    kycNotVerifiedTitle: "Verificacion KYC requerida",
    kycNotVerifiedDesc: "Su identidad aun no ha sido verificada. Complete la verificacion KYC para poder solicitar un retiro.",
    verifyKycNow: "Verificar ahora"
  },
  payoutEligibility: {
    title: "Elegibilidad de Pago",
    loading: "Verificando elegibilidad de pago...",
    error: "No se pudo verificar la elegibilidad. Por favor intenta de nuevo mas tarde.",
    eligible: "Eres elegible para un pago",
    notEligible: "Aun no eres elegible para un pago",
    rules: "Reglas",
    passed: "aprobadas",
    checkPassed: "Aprobado",
    checkFailed: "Fallido",
    required: "Requerido",
    actual: "Actual",
    maxPayout: "Monto Maximo de Pago",
  },
  payoutMethods: {
    title: "Metodos de Pago",
    subtitle: "Administra tus metodos de pago",
    add: "Agregar Metodo",
    paypal: "PayPal",
    default: "Predeterminado",
    setDefault: "Establecer como Predeterminado",
    addPaymentMethod: "Agregar Metodo de Pago",
    bankTransfer: "Transferencia Bancaria",
    bankTransferDesc: "Transferencia bancaria directa",
    paypalDesc: "Pagos por PayPal",
    crypto: "Criptomoneda",
    cryptoDesc: "Pagos con criptomoneda",
    ach: "Transferencia ACH",
    achDesc: "Transferencia bancaria directa via ACH",
    accountHolder: "Titular de la Cuenta",
    iban: "IBAN",
    bicSwift: "BIC/SWIFT",
    bankName: "Nombre del Banco",
    routingNumber: "Numero de Ruta",
    accountNumber: "Numero de Cuenta",
    enterRoutingNumber: "Ingresa el numero de ruta",
    enterAccountNumber: "Ingresa el numero de cuenta",
    paypalEmail: "Correo de PayPal",
    walletAddress: "Direccion de Wallet",
    currencyType: "Tipo de Moneda",
    accountCurrency: "Moneda de la Cuenta",
    paypalCurrency: "Moneda de PayPal",
    enterAccountHolder: "Ingresa el nombre del titular de la cuenta",
    enterIban: "Ingresa el IBAN",
    enterBicSwift: "Ingresa el codigo BIC/SWIFT",
    enterBankName: "Ingresa el nombre del banco",
    enterPaypalEmail: "Ingresa el correo de PayPal",
    enterWalletAddress: "Ingresa la direccion de wallet",
    enterCurrencyType: "Ingresa el tipo de moneda",
    cancel: "Cancelar",
    saveMethod: "Guardar Metodo",
    secureEncrypted: "Seguro y Encriptado",
    securityNote: "Toda la informacion de pago esta encriptada y almacenada de forma segura. Nunca almacenamos datos de pago sensibles."
  },
  payoutHistory: {
    title: "Historial de Pagos",
    payoutsFound: "pagos encontrados",
    export: "Exportar",
    allPayouts: "Todos los Pagos",
    completed: "Completados",
    processing: "En Proceso",
    failed: "Fallidos",
    searchPlaceholder: "Buscar pagos...",
    payoutId: "ID de Pago",
    amount: "Monto",
    method: "Metodo",
    status: "Estado",
    requestDateTime: "Fecha/Hora de Solicitud",
    completedDateTime: "Fecha/Hora de Completado",
    account: "Cuenta",
    reference: "Referencia",
    action: "Accion",
    fee: "Comision",
    net: "Neto",
    pending: "Pendiente",
    cancelPayout: "Cancelar Pago",
    showing: "Mostrando",
    of: "de",
    payouts: "pagos",
    previous: "Anterior",
    next: "Siguiente",
    totalNet: "Total Neto",
    statusPending: "Pendiente",
    statusCanceled: "Cancelado",
    statusCompleted: "Completado",
    canceledByUser: "Cancelado por el usuario",
    noReasonProvided: "No se proporciono razon",
    noPayoutsFound: "No se encontraron pagos",
    noPayoutsMessage: "No hay registros de pagos que coincidan con tus filtros",
    loading: "Cargando pagos...",
    pleaseWait: "Por favor espera..."
  },
  support: {
    title: "Centro de Soporte",
    subtitle: "Estamos aquí para ayudarte",
    premiumSupport: "Soporte Premium",
    helpAndFaq: "Ayuda y Preguntas Frecuentes",
    helpAndSupport: "Ayuda y Soporte",
    getHelpWhenNeeded: "Obtiene ayuda cuando la necesites",
    available247: "Disponible 24/7",
    maintenanceTitle: "Area de Soporte en Construccion",
    maintenanceMessage: "Actualmente estamos activando y finalizando la nueva area de soporte. Mientras tanto, por favor envia todas tus preguntas a:",
    maintenanceEmail: "support@nextproptrader.com",
    contactUs: "Contáctanos",
    emailDescription: "Envíanos un correo electrónico y nuestro equipo de soporte se pondrá en contacto contigo lo antes posible.",
    clickToEmail: "Haz clic para enviar email",
    responseTime: "Tiempo de respuesta típico dentro de 24 horas"
  },
  supportStats: {
    responseTime: "Tiempo de Respuesta",
    resolutionRate: "Tasa de Resolucion",
    activeTickets: "Tickets Activos",
    satisfaction: "Satisfaccion",
    average: "Promedio",
    businessHours: "horas habiles",
    firstContact: "Primer contacto",
    resolution: "resolucion",
    vsYesterday: "vs ayer",
    thisMonth: "este mes"
  },
  supportTickets: {
    title: "Tickets de Soporte",
    subtitle: "Sigue y gestiona tus tickets",
    loading: "Cargando tickets...",
    ticketsFound: "tickets encontrados",
    noTicketsFound: "No se encontraron tickets",
    adjustFilters: "Intenta ajustar tus filtros o termino de busqueda",
    createdLabel: "Creado:",
    updatedLabel: "Actualizado:",
    all: "Todos",
    open: "Abiertos",
    closed: "Cerrados",
    resolved: "Resueltos",
    status_open: "ABIERTO",
    status_pending: "PENDIENTE",
    status_in_progress: "EN PROCESO",
    status_resolved: "RESUELTO",
    status_closed: "CERRADO",
    priority_low: "BAJA",
    priority_medium: "MEDIA",
    priority_high: "ALTA",
    priority_urgent: "URGENTE",
    searchPlaceholder: "Buscar tickets...",
    ticketId: "ID de Ticket",
    subject: "Asunto",
    status: "Estado",
    priority: "Prioridad",
    created: "Creado",
    assignedTo: "Asignado A",
    ticketDetails: "Detalles del Ticket",
    category: "Categoria",
    lastUpdate: "Ultima Actualizacion",
    conversation: "Conversacion",
    messages: "mensajes",
    typeMessage: "Escribe tu mensaje...",
    sendMessage: "Enviar Mensaje",
    sending: "Enviando...",
    ticketResolved: "Este ticket ha sido resuelto",
    noMoreMessages: "No se pueden enviar mas mensajes",
    closingTicket: "Cerrando Ticket...",
    closeTicket: "Cerrar Ticket",
    showing: "Mostrando",
    of: "de",
    tickets: "tickets",
    previous: "Anterior",
    next: "Siguiente",
    noMessages: "Aun no hay mensajes",
    you: "Tu",
    supportTeam: "Equipo de Soporte",
    attachment: "Archivo adjunto",
    attachFile: "Adjuntar archivo",
    attachments: "Archivos adjuntos",
    uploading: "Subiendo...",
    uploadFailed: "Error al subir",
    uploadingAttachments: "Subiendo archivos adjuntos...",
    fileTooLarge: "Archivo demasiado grande (max 10 MB)",
    invalidFileType: "Tipo de archivo no valido",
    allowedTypes: "Permitidos: jpg, png, gif, pdf, doc, docx, txt, zip, rar",
    downloadAttachment: "Descargar",
    removeAttachment: "Eliminar"
  },
  knowledgeBase: {
    title: "Base de Conocimiento",
    subtitle: "Encuentra respuestas rapidamente",
    searchPlaceholder: "Buscar articulos...",
    allArticles: "Todos los Articulos",
    gettingStarted: "Primeros Pasos",
    platformGuide: "Guia de la Plataforma",
    evaluationProcess: "Proceso de Evaluacion",
    payoutsBilling: "Pagos y Facturacion",
    troubleshooting: "Solucion de Problemas",
    popular: "POPULAR",
    readTime: "lectura",
    views: "vistas",
    updatedLabel: "Actualizado:",
    noArticlesFound: "No se encontraron articulos",
    adjustSearch: "Intenta ajustar tu termino de busqueda o categoria",
    articlesFound: "articulos encontrados",
    viewAll: "Ver Todo"
  },
  liveChat: {
    title: "Soporte",
    subtitle: "Crear un ticket",
    available247: "Disponible 24/7",
    initialBotMessage: "Hola! Estoy aqui para ayudarte con cualquier pregunta o problema que puedas tener. Como puedo asistirte hoy?",
    supportAvailable: "Soporte Disponible",
    averageResponse: "Respuesta promedio: < 2 horas",
    newTicket: "Nuevo Ticket",
    quickHelpTopics: "Temas de Ayuda Rapida",
    accountLoginIssues: "Problemas de Cuenta e Inicio de Sesion",
    platformTechnicalSupport: "Soporte Tecnico de Plataforma",
    payoutQuestions: "Preguntas sobre Pagos",
    evaluationProcessHelp: "Ayuda con el Proceso de Evaluacion",
    priority: "prioridad",
    responseTimes: "Tiempos de Respuesta",
    highPriorityText: "Alta Prioridad",
    mediumPriorityText: "Prioridad Media",
    lowPriorityText: "Baja Prioridad",
    supportTeam: "Equipo de Soporte",
    available: "Disponible",
    ticketSubject: "Asunto del Ticket",
    describeIssue: "Describe tu problema...",
    ticketCreated: "Ticket Creado",
    closeTicket: "Cerrar Ticket",
    ticketCreatedSuccess: "Gracias por contactar al soporte! Tu ticket ha sido creado con el ID: {{ticketId}}. Nuestro equipo revisara tu solicitud y respondera en unas horas durante el horario laboral.",
    ticketCreationError: "Lo sentimos, encontramos un error al crear tu ticket. Por favor intenta de nuevo o contacta al soporte directamente.",
    responses: {
      concern: "Entiendo tu preocupacion. Dejame investigar esto por ti.",
      escalate: "Gracias por la informacion adicional. Escalare esto a nuestro equipo tecnico.",
      question: "Esa es una excelente pregunta! Dejame proporcionarte los detalles.",
      noted: "He anotado esto en tu ticket. Nuestro equipo investigara mas a fondo.",
      anything: "Hay algo mas en lo que pueda ayudarte respecto a este problema?"
    },
    whatHappensNext: "Que sucede despues?",
    whatHappensNextDescription: "Nuestro equipo de soporte revisara tu ticket y respondera dentro del plazo esperado segun tu nivel de prioridad. Recibiras actualizaciones por correo electronico.",
    createAnotherTicket: "Crear Otro Ticket",
    ticketIdLabel: "ID de Ticket",
    statusLabel: "Estado",
    statusOpen: "ABIERTO",
    creatingTicket: "Creando ticket...",
    categoryLabel: "Categoria",
    categories: {
      general: "General",
      account: "Cuenta",
      technical: "Tecnico",
      payout: "Pago",
      evaluation: "Evaluacion"
    }
  },
  faqSection: {
    badge: "Preguntas Frecuentes",
    title: "Todo lo que Necesitas",
    titleHighlight: "Saber",
    subtitle: "Respuestas a las preguntas mas importantes sobre nuestro programa de prop trading.",
    questions: {
      q1: {
        question: "Como funciona el reparto de ganancias del 100%?",
        answer: "Conservas el 100% de las ganancias que generas en tu cuenta funded. No tomamos ninguna comision porque nuestro modelo de negocio funciona diferente: cuando operas de forma rentable, replicamos tus operaciones en segundo plano con posiciones mas grandes. Tu exito es nuestro exito — por eso invertimos en tu rendimiento a largo plazo, no en vender evaluaciones."
      },
      q2: {
        question: "Cuales son las reglas de la evaluacion?",
        answer: "Hay 4 reglas simples: (1) Necesitas un minimo de 5 dias de trading para aprobar la evaluacion — no hay maximo de dias de trading. (2) No excedas el tamano maximo de lote de tu cuenta. (3) Mantente por encima del trailing drawdown. (4) Cierra todas las posiciones antes de las 3:15 PM CST — el trading se reanuda a las 5:00 PM CST. El objetivo de ganancia es del 6-8% segun el tamano de la cuenta."
      },
      q3: {
        question: "Que es la Lucky Punch Rule y el Scaling Plan?",
        answer: "En la cuenta funded solo hay 2 reglas. La Lucky Punch Rule: ningun trade puede representar mas del 30% de tu P&L total, asegurando un rendimiento consistente. El Scaling Plan: comienzas con 1 contrato y desbloqueas 1 contrato adicional por cada $2,500 de ganancia. Despues de $2,500 de ganancia puedes operar 2 contratos, despues de $5,000 desbloqueas 3, y asi sucesivamente."
      },
      q4: {
        question: "Que tan rapido puedo ser funded y recibir pagos?",
        answer: "Puedes aprobar la evaluacion en tan solo 5 dias de trading. Una vez aprobada, tu cuenta funded se activa generalmente en 24 horas en dias habiles. Los pagos se pueden solicitar diariamente — ofrecemos transferencia bancaria, PayPal y criptomonedas. El monto minimo es de $50 y el procesamiento toma de 1 a 3 dias habiles."
      },
      q5: {
        question: "Que fuentes de datos y plataformas utilizan?",
        answer: "Utilizamos fuentes de datos de Rithmic y DXFeed, proporcionando datos de mercado Level 2 en tiempo real con ejecucion sub-milisegundo. Se soportan todas las plataformas que puedan establecer una conexion Rithmic o DXFeed. Todas las cuentas incluyen datos de mercado CME Non-Professional sin costo adicional."
      },
      q6: {
        question: "Que es el trailing drawdown y como funciona?",
        answer: "El trailing drawdown es un limite dinamico de perdida maxima que sube cuando tu cuenta alcanza nuevos maximos. Ejemplo: si tu cuenta comienza en $50,000 con un trailing drawdown de $2,500, tu piso es $47,500. Si tu saldo sube a $52,000, el piso se mueve a $49,500. El drawdown siempre sigue tu saldo mas alto."
      },
      q7: {
        question: "Cuantas cuentas puedo operar al mismo tiempo?",
        answer: "No hay limite. Puedes operar tantas cuentas como desees simultaneamente. Ya sea que prefieras gestionar una sola cuenta o varias a la vez, la eleccion es completamente tuya."
      },
      q8: {
        question: "Que pasa si no apruebo o no lo logro a tiempo?",
        answer: "Para cuentas de evaluacion, puedes reiniciar tu cuenta por una tarifa y empezar de nuevo. Tambien puedes extender tu cuenta en cualquier momento para obtener mas tiempo. Para cuentas funded, si violas las reglas, necesitaras aprobar una nueva evaluacion para ser funded nuevamente. Tanto las cuentas de evaluacion como las funded pueden extenderse en cualquier momento."
      },
      q9: {
        question: "Hay una tarifa funded para cuentas funded?",
        answer: "Si, una vez que tienes una cuenta funded hay una tarifa funded mensual de 95 EUR. Esta tarifa cubre todos los costos de software y datos, incluyendo datos de mercado en tiempo real e infraestructura tecnica. Lo mejor: los 95 EUR cubren TODAS tus cuentas funded combinadas — ya sea que tengas 1 o 10 cuentas, solo pagas 95 EUR al mes. La tarifa solo se cobra una vez que hayas aprobado exitosamente la evaluacion."
      }
    },
    titleDashboard: "Preguntas Frecuentes",
    subtitleDashboard: "Encuentra respuestas a preguntas comunes",
    allCategories: "Todas las Categorias",
    general: "General",
    trading: "Trading",
    gettingStarted: "Primeros Pasos",
    evaluation: "Evaluacion",
    platform: "Plataforma",
    payouts: "Pagos",
    account: "Cuenta",
    rules: "Reglas",
    articlesFound: "articulos encontrados",
    searchPlaceholder: "Buscar articulos...",
    howToStartEvaluation: "Como inicio una evaluacion?",
    howToStartEvaluationAnswer: "Elige tu tamano de cuenta ($10K-$250K) en la pagina de precios y completa la compra. Tu cuenta de evaluacion se configura automaticamente y puedes empezar a operar de inmediato. El periodo minimo de evaluacion es de 5 dias de trading.",
    whatIsProfitTarget: "Cual es el objetivo de ganancia?",
    whatIsProfitTargetAnswer: "El objetivo de ganancia es del 6-8% del tamano de tu cuenta, dependiendo del tier que elijas. Por ejemplo, en una cuenta de $50K con un objetivo del 6%, necesitarias alcanzar $3,000 de ganancia. No hay limite de tiempo — tomate el tiempo que necesites.",
    howLongEvaluation: "Hay un limite de tiempo para la evaluacion?",
    howLongEvaluationAnswer: "No hay limite de tiempo maximo para completar tu evaluacion. Necesitas un minimo de 5 dias de trading para aprobar. Puedes tomarte todos los dias que necesites para alcanzar el objetivo de ganancia mientras sigues las reglas.",
    howToRequestPayout: "Como solicito un pago?",
    howToRequestPayoutAnswer: "Ve a tu Wallet en el dashboard y selecciona la pestana de Pago. Elige tu cuenta funded, ingresa el monto (minimo $50) y selecciona tu metodo preferido: transferencia bancaria, PayPal o criptomoneda. Los pagos se procesan en 1 a 3 dias habiles.",
    whatIsTrailingDrawdown: "Que es el trailing drawdown?",
    whatIsTrailingDrawdownAnswer: "El trailing drawdown es un limite de perdida dinamico que sube cuando tu cuenta alcanza nuevos maximos de saldo. Si tu cuenta alcanza un maximo de $52,000 con un drawdown de $2,500, tu piso es $49,500. Nunca baja. Esto asegura una gestion de riesgo responsable durante todo tu trading.",
    canIUseEA: "Puedo usar Expert Advisors (EAs) o estrategias automatizadas?",
    canIUseEAAnswer: "Si, los EAs y estrategias automatizadas estan permitidos en nuestra plataforma. Sin embargo, no deben usar estrategias prohibidas como arbitraje, cobertura entre multiples cuentas, scalping de ticks o cualquier forma de explotacion de latencia. Las estrategias algoritmicas estandar son bienvenidas.",
    whatTradingHours: "Cuales son los horarios de trading?",
    whatTradingHoursAnswer: "Todas las posiciones deben cerrarse antes de las 3:15 PM CST como maximo. El trading se reanuda a las 5:00 PM CST. Esto aplica tanto para cuentas de evaluacion como funded. Mantener posiciones despues del cierre no esta permitido y puede resultar en una violacion de reglas.",
    howToChangePassword: "Como cambio mi contrasena o configuracion de seguridad?",
    howToChangePasswordAnswer: "Navega a tu pagina de Perfil, luego abre la pestana de Configuracion. En la seccion de Seguridad, puedes cambiar tu contrasena y activar la autenticacion de dos factores para proteccion adicional.",
    whatDataFeeds: "Que fuentes de datos y datos de mercado proporcionan?",
    whatDataFeedsAnswer: "Usamos Rithmic y DXFeed como proveedores de datos. Cada cuenta incluye datos de mercado Level 2 en tiempo real y datos CME Non-Professional sin costo adicional. Esto garantiza precios precisos con velocidades de ejecucion sub-milisegundo.",
    howToExtendAccount: "Puedo extender o reiniciar mi cuenta de evaluacion?",
    howToExtendAccountAnswer: "Si. Puedes extender tu cuenta por 30 dias adicionales o reiniciarla para empezar de nuevo, todo directamente desde tu dashboard. Tambien puedes ganar reinicios y extensiones gratuitas a traves de nuestro sistema de logros y niveles.",
    whatIsLuckyPunch: "Que es la Lucky Punch Rule?",
    whatIsLuckyPunchAnswer: "La Lucky Punch Rule significa que ningun trade puede exceder el 30% de tu P&L total en una cuenta funded. Por ejemplo, si tu ganancia total es de $5,000, ningun trade individual deberia haber contribuido mas de $1,500. Esto asegura un rendimiento consistente en lugar de depender de un solo trade afortunado.",
    whatIsScalingPlan: "Como funciona el Scaling Plan?",
    whatIsScalingPlanAnswer: "Comienzas con 1 contrato en tu cuenta funded. Por cada $2,500 de ganancia acumulada, desbloqueas 1 contrato adicional. Despues de $2,500 de ganancia puedes operar 2 contratos, despues de $5,000 desbloqueas 3 contratos, y asi sucesivamente. Esto asegura que aumentes tu tamano de posicion gradualmente a medida que tu cuenta crece.",
    whatPayoutMethods: "Que metodos de pago estan disponibles?",
    whatPayoutMethodsAnswer: "Ofrecemos transferencia bancaria, PayPal y pagos en criptomoneda. El monto minimo de pago es de $50. El procesamiento toma de 1 a 3 dias habiles. Puedes solicitar pagos diariamente desde tu wallet del dashboard. No hay comisiones ocultas.",
    whatAccountSizes: "Que tamanos de cuenta estan disponibles?",
    whatAccountSizesAnswer: "Ofrecemos cuentas de evaluacion desde $10,000 hasta $250,000 en capital de trading. Cada tier de cuenta tiene su propio objetivo de ganancia, tamano maximo de lote y limite de trailing drawdown. Todas las cuentas incluyen datos de mercado Level 2, fuentes de datos CME Non-Professional y soporte 24/7.",
    howManyAccounts: "Cuantas cuentas puedo operar al mismo tiempo?",
    howManyAccountsAnswer: "No hay limite. Puedes operar tantas cuentas como desees simultaneamente. Ya sea que prefieras gestionar una sola cuenta o varias a la vez, la eleccion es completamente tuya.",
    whatIfIFail: "Que pasa si no apruebo o no lo logro a tiempo?",
    whatIfIFailAnswer: "Para cuentas de evaluacion, puedes reiniciar tu cuenta por una tarifa y empezar de nuevo. Tambien puedes extender tu cuenta en cualquier momento. Para cuentas funded, si violas las reglas, necesitaras aprobar una nueva evaluacion. Tanto las cuentas de evaluacion como las funded pueden extenderse en cualquier momento.",
    priority: "Prioridad",
    highPriorityText: "Alta Prioridad",
    mediumPriorityText: "Prioridad Media",
    lowPriorityText: "Baja Prioridad",
    noResults: "No se encontraron articulos",
    tryDifferentSearch: "Intenta un termino de busqueda o filtro diferente.",
    contactTitle: "Aun tienes preguntas?",
    contactDescription: "Nuestro equipo esta aqui para ayudarte. Contactanos y te responderemos lo antes posible.",
    contactButton: "Contactanos"
  },
  notifications: {
    title: "Notificaciones",
    unread: "sin leer",
    markAllRead: "Marcar todo como leido",
    noNotifications: "Sin Notificaciones",
    allCaughtUp: "Estas al dia!",
    lastUpdated: "Ultima actualizacion",
    tradeClosedTitle: "Operacion Cerrada Exitosamente",
    tradeClosedMessage: "Tu posicion NQ1! fue cerrada con +$285 de ganancia",
    minutesAgo: "hace {minutes} minutos",
    payoutProcessedTitle: "Pago Procesado",
    payoutProcessedMessage: "Tu pago de $2,450 ha sido enviado a tu cuenta bancaria",
    hourAgo: "hace 1 hora",
    achievementUnlockedTitle: "Logro Desbloqueado!",
    achievementUnlockedMessage: "Has obtenido el logro 'Maestro del Riesgo'",
    hoursAgo: "hace {hours} horas",
    riskAlertTitle: "Alerta de Gestion de Riesgo",
    riskAlertMessage: "Tu cuenta se esta acercando al limite de drawdown diario",
    marketUpdateTitle: "Actualizacion de Mercado",
    marketUpdateMessage: "Se espera alta volatilidad durante la publicacion del NFP",
    dayAgo: "hace 1 dia",
    accountVerifiedTitle: "Cuenta Verificada",
    accountVerifiedMessage: "Tu verificacion de identidad ha sido completada"
  },
  chatModal: {
    lastSeen: "Ultima vez",
    typeMessage: "Escribe un mensaje...",
    viewProfile: "Ver Perfil",
    blockUser: "Bloquear Usuario",
    reportUser: "Reportar Usuario",
    deleteChat: "Eliminar Chat"
  },
  chatOverview: {
    title: "Mensajes",
    unread: "sin leer",
    blockUser: "Bloquear Usuario",
    reportUser: "Reportar Usuario",
    delete: "Eliminar",
    noMessages: "Sin Mensajes",
    startConversation: "Inicia una conversacion con otros traders",
    viewAllConversations: "Ver Todas las Conversaciones",
    totalConversations: "conversaciones totales",
    lastUpdated: "Ultima actualizacion"
  },
  fundedAgreement: {
    title: "Acuerdo de Cuenta Financiada",
    legalDocument: "Documento Legal",
    signToActivate: "Firma para activar tu cuenta financiada",
    evaluationPassed: "Evaluacion Aprobada",
    account: "Cuenta",
    finalPnL: "P&L Final",
    evaluationResult: "Resultado de la Evaluacion",
    passedDate: "Fecha de Aprobacion",
    completionDate: "Fecha de Finalizacion",
    fundedCapital: "Capital Financiado",
    tradingCapital: "Capital de Trading",
    agreementTerms: "Terminos del Acuerdo",
    pleaseReviewCarefully: "Por favor revisa cuidadosamente antes de firmar",
    firstName: "Nombre",
    lastName: "Apellido",
    address: "Direccion",
    city: "Ciudad",
    zipCode: "Codigo Postal",
    country: "Pais",
    emailAddress: "Correo Electronico",
    addressPlaceholder: "Ingresa tu direccion",
    cityPlaceholder: "Ingresa tu ciudad",
    zipCodePlaceholder: "Ingresa tu codigo postal",
    countryPlaceholder: "Selecciona tu pais",
    digitalSignature: "Firma Digital",
    clear: "Limpiar",
    signHereWithMouseOrFinger: "Firma aqui con el raton o el dedo",
    pleaseSignAboveToExecute: "Por favor firma arriba para ejecutar el acuerdo",
    signToActivateAccount: "Firma para activar tu cuenta",
    identificationDocument: "Documento de Identificacion",
    uploadNewDocument: "Subir Nuevo Documento",
    useExistingDocument: "Usar Documento Existente",
    documentSecurity: "Seguridad de Documentos",
    documentSecurityDesc: "Todos los documentos estan encriptados y almacenados de forma segura en cumplimiento con las regulaciones de proteccion de datos.",
    printedName: "Nombre Impreso",
    printedNameDesc: "Escribe tu nombre legal completo en letras mayusculas",
    printedNameNote: "Debe coincidir con el nombre en tu documento de identificacion",
    agreementCheckbox: "He leido y acepto todos los terminos y condiciones de este Acuerdo de Cuenta Financiada",
    signAgreement: "Firmar Acuerdo",
    signingAgreement: "Firmando Acuerdo...",
    requirementsChecklist: "Lista de Requisitos",
    personalDataComplete: "Datos personales completos",
    agreementAcceptance: "Aceptacion del acuerdo",
    importantNotice: "Aviso Importante",
    noticeText1: "Este es un acuerdo legalmente vinculante. Por favor lee todos los terminos cuidadosamente antes de firmar.",
    noticeText2: "Al firmar este acuerdo, reconoces que entiendes y aceptas todos los terminos y condiciones.",
    noticeText3: "Una vez firmado, este acuerdo no puede ser modificado sin consentimiento mutuo de ambas partes.",
    loadingContract: "Cargando contrato...",
    errorLoadingContract: "Error al cargar el contrato"
  },
  agreementSuccess: {
    title: "Acuerdo Firmado Exitosamente!",
    description: "Tu Acuerdo de Cuenta Financiada para la cuenta #{accountId} ha sido firmado y procesado.",
    accountCreationInfo: "Tu cuenta financiada esta siendo preparada y estara disponible dentro de 24 horas.",
    fundedFeeTitle: "Cuota Mensual de Cuenta Financiada",
    fundedFeeSubtitle: "Requerida para la activacion de la cuenta",
    activeSubscription: "Suscripcion Activa",
    activeSubscriptionDesc: "Tu suscripcion de cuota de cuenta financiada esta activa hasta:",
    paymentRequired: "Pago Requerido",
    paymentRequiredDesc: "Para activar tu cuenta financiada, por favor paga la cuota mensual de 95 EUR.",
    payFundedFee: "Pagar Cuota (95 EUR)",
    signedBy: "Firmado Por",
    signedOn: "Firmado El",
    account: "Cuenta",
    status: "Estado",
    active: "Activo",
    waitingForPayment: "Esperando Pago",
    backToDashboard: "Volver al Panel",
    loadingStatus: "Cargando estado del contrato...",
    accountActivating: "Cuenta Activandose",
    accountActivatingDesc: "Tu cuenta financiada sera activada en unos segundos."
  },
  profile: {
    title: "Perfil"
  },
  profileTabs: {
    activity: "Actividad",
    achievements: "Logros",
    connections: "Conexiones",
    documents: "Documentos",
    settings: "Configuracion"
  },
  profileHeader: {
    publicProfile: "Perfil Publico",
    privateProfile: "Perfil Privado",
    trades: "Operaciones",
    tradingDays: "Dias de Trading",
    seasons: "Temporadas",
    joined: "Se unio",
    follow: "Seguir",
    message: "Mensaje",
    messagesDisabled: "Mensajes Deshabilitados"
  },
  userHeader: {
    eliteTrader: "Trader Elite",
    higherProfitSplits: "Mayor reparto de ganancias",
    prioritySupport: "Soporte prioritario",
    exclusiveFeatures: "Funciones exclusivas",
    dayStreak: "Racha de Dias",
    day: "dia",
    days: "dias",
    tradingConsistency: "Consistencia de Trading",
    currentStreak: "Racha Actual",
    bestStreak: "Mejor Racha",
    started: "Iniciado",
    lastTrade: "Ultima Operacion",
    recentTradingDays: "Dias de Trading Recientes",
    trades: "operaciones",
    keepTradingDaily: "Sigue operando diariamente para mantener tu racha!",
    amazingConsistency: "Increible consistencia! Estas en racha!",
    greatMomentum: "Gran impulso! Sigue asi!",
    buildingHabits: "Construyendo grandes habitos de trading!",
    keepItUp: "Sigue asi! Cada dia cuenta!",
    noStreakTitle: "Sin Racha Aun",
    noStreakMessage: "Comienza a operar para construir tu racha! Cada dia de trading cuenta para tu consistencia.",
    level: "Nivel",
    progressTo: "Progreso hacia",
    currentLevel: "Nivel Actual",
    nextLevel: "Beneficios del Siguiente Nivel",
    nextRank: "Siguiente Rango",
    nextRankAt: "en el Nivel",
    currentRank: "Rango Actual",
    rankBenefits: "Beneficios del Rango",
    maxRankReached: "Rango maximo alcanzado!",
    rewardCredits: "Creditos",
    rewardDiscount: "Descuento Unico",
    rewardFreeReset: "Reset Gratuito",
    rewardFreeExtension: "Extension Gratuita",
    rewardTradingFee: "Comision de Trading",
    rewardDrawdownReduction: "Reduccion de Drawdown",
    account: "Cuenta",
    tier: "Estado",
    accounts: "Cuentas",
    funded: "Financiada",
    evaluation: "Evaluacion",
    inactive: "Inactiva"
  },
  achievements: {
    title: "Logros",
    subtitle: "Tus hitos de trading",
    completed: "completados",
    progress: "Progreso",
    earned: "Obtenidos",
    remaining: "Restantes",
    previous: "Anterior",
    next: "Siguiente",
    page: "Pagina",
    of: "de",
    viewAll: "Ver Todos los Logros",
    achievementStatus: "Estado del logro",
    loading: "Cargando logros...",
    locked: "Bloqueado",
    noAchievements: "Aun No Hay Logros",
    noAchievementsDesc: "Comienza a operar para desbloquear tu primer logro y seguir tu progreso!",
    startTrading: "Comienza tu camino",
    rarity: {
      common: "Comun",
      rare: "Raro",
      epic: "Epico",
      legendary: "Legendario",
      special: "Especial"
    },
    firstProfit: {
      title: "Primera Ganancia",
      description: "Realizaste tu primera operacion rentable"
    },
    profitStreak: {
      title: "Racha de Ganancias",
      description: "5 dias rentables consecutivos"
    },
    riskMaster: {
      title: "Maestro del Riesgo",
      description: "Nunca excediste el 3% de drawdown diario durante 30 dias"
    },
    speedDemon: {
      title: "Velocista",
      description: "Aprobaste la evaluacion en 5 dias"
    },
    consistencyKing: {
      title: "Rey de la Consistencia",
      description: "15 dias de trading activo"
    },
    profitTarget: {
      title: "Objetivo de Ganancia",
      description: "Alcanzaste el 6% de objetivo de ganancia"
    },
    highRoller: {
      title: "Gran Apostador",
      description: "Opera con capital de $100K+"
    },
    winStreak: {
      title: "Racha de Victorias",
      description: "10 operaciones ganadoras seguidas"
    },
    perfectMonth: {
      title: "Mes Perfecto",
      description: "Sin dias perdedores en un mes"
    },
    volumeTrader: {
      title: "Trader de Volumen",
      description: "Ejecuta 1000+ operaciones"
    },
    profitMachine: {
      title: "Maquina de Ganancias",
      description: "Gana $100K+ en ganancias totales"
    },
    diamondHands: {
      title: "Manos de Diamante",
      description: "Mantiene una posicion ganadora por 24+ horas"
    }
  },
  achievementModal: {
    details: "Detalles",
    difficulty: "Dificultad",
    status: "Estado",
    earned: "Obtenido",
    statusLocked: "Bloqueado",
    earnedOn: "Obtenido El",
    progress: "Progreso",
    reward: "Recompensa",
    tips: "Consejos",
    unlocked: "Logro Desbloqueado!",
    congratulations: "Felicidades por desbloquear este logro!",
    locked: "Logro Bloqueado",
    completeRequirements: "Completa los requisitos para desbloquear este logro.",
    rarity: "Rareza",
    points: "Puntos",
    completed: "Completado!",
    target: "Objetivo",
    current: "Actual",
    description: "Descripcion"
  },
  profileAchievements: {
    title: "Logros",
    progress: "Progreso",
    rarityBreakdown: "Desglose por Rareza",
    achievementDistribution: "Distribucion de logros",
    recentUnlocks: "Desbloqueos Recientes",
    latestAchievements: "Ultimos logros",
    all: "Todos",
    earned: "obtenidos",
    complete: "completo",
    rarityDesc: {
      common: "Logros basicos",
      rare: "Rendimiento habil",
      epic: "Trading excepcional",
      legendary: "Dominio de elite",
      special: "Recompensas unicas"
    }
  },
  profileSeasons: {
    tradingSeasons: "Temporadas de Trading",
    season: "Temporada",
    pastSeasons: "Temporadas Anteriores",
    finalLevel: "Nivel Final",
    level: "Nivel",
    current: "Actual"
  },
  profileTradingStats: {
    title: "Estadisticas de Trading",
    totalTrades: "Total de Operaciones",
    allTimeExecuted: "Total ejecutadas en todo el tiempo",
    tradedLots: "Lots Operados",
    totalExecuted: "Total ejecutado",
    winRate: "Tasa de Acierto",
    profitFactor: "Factor de Ganancia",
    riskAdjusted: "Ajustado al riesgo",
    averagePerformance: "Rendimiento Promedio",
    avgWin: "Ganancia Prom.",
    avgLoss: "Perdida Prom.",
    dailyProfit: "P&L diario prom.",
    extremes: "Extremos",
    bestDay: "Mejor Dia",
    worstDay: "Peor Dia",
    tradingDays: "Dias de Trading",
    consistency: "Consistencia",
    maxWins: "Max Ganancias",
    maxLosses: "Max Perdidas",
    largestWin: "Mayor Ganancia",
    tradingHoursDistribution: "Distribucion de Horarios de Trading",
    lots: "lots",
    trades: "operaciones",
    marketDistribution: "Distribucion de Mercado",
    totalLots: "Lots Totales",
    ofTotal: "del total",
    noData: "Aun no hay operaciones cerradas disponibles."
  },
  profileConnections: {
    title: "Red de Trading",
    tradingNetwork: "Red de Trading",
    connectWithTraders: "Conecta con traders",
    total: "Total",
    followers: "Seguidores",
    following: "Siguiendo",
    searchConnections: "Buscar conexiones...",
    searchNewByUsername: "Buscar nuevo por nombre de usuario...",
    userFound: "Usuario Encontrado",
    follow: "Seguir",
    notFound: "No Encontrado",
    tier: "Nivel",
    funded: "Financiada",
    evaluation: "Evaluacion",
    seasons: "Temporadas",
    trades: "Operaciones",
    lastActive: "Ultima actividad",
    unfollow: "Dejar de Seguir"
  },
  documents: {
    title: "Documentos",
    documentCenter: "Centro de Documentos",
    invoicesAgreements: "Facturas y acuerdos",
    invoiceTabTitle: "Facturas",
    agreementsTabTitle: "Acuerdos",
    all: "Todos",
    paid: "Pagados",
    active: "Activos",
    pending: "Pendientes",
    searchInvoices: "Buscar facturas...",
    searchAgreements: "Buscar acuerdos...",
    invoices: "Facturas",
    invoicesFound: "facturas encontradas",
    fundedAgreements: "Acuerdos de Cuenta Financiada",
    agreementsFound: "acuerdos encontrados",
    invoice: "Factura",
    amount: "Monto",
    fundedAgreement: "Acuerdo de Cuenta Financiada",
    account: "Cuenta",
    signed: "Firmado",
    evaluationPassed: "Evaluacion aprobada",
    contractCreated: "Contrato creado",
    pendingSignature: "Firma Pendiente",
    completed: "Completado",
    passedAccount: "Cuenta Aprobada",
    fundedAccount: "Cuenta Financiada",
    terminated: "Terminado",
    awaitingFee: "Esperando Cuota",
    payFundedFee: "Pagar Cuota de Cuenta Financiada",
    noInvoicesFound: "No se Encontraron Facturas",
    noInvoicesFoundCriteria: "No hay facturas que coincidan con tus criterios de busqueda actuales.",
    status: {
      paid: "Pagado",
      active: "Activo",
      pending: "Pendiente",
      terminated: "Terminado",
      Terminated: "Terminado",
      failed: "Fallido",
      Completed: "Completado",
      PendingSignature: "Firma Pendiente",
      AwaitingFee: "Esperando Cuota",
      Provisioning: "Aprovisionamiento"
    }
  },
  profileSettings: {
    title: "Configuracion del Perfil",
    customizationHub: "Centro de Personalizacion",
    personalizeExperience: "Personaliza tu experiencia",
    profile: "Perfil",
    privacy: "Privacidad",
    notifications: "Notificaciones",
    security: "Seguridad",
    manageProfileInfo: "Administra la informacion de tu perfil",
    controlWhoCanSee: "Controla quien puede ver tu informacion",
    customizeNotifications: "Personaliza tus notificaciones",
    secureAccount: "Protege tu cuenta",
    settingsSaved: "Configuracion Guardada!",
    savingChanges: "Guardando Cambios...",
    saveChanges: "Guardar Cambios",
    saveAllChanges: "Guardar Todos los Cambios",
    settings: "Configuracion"
  },
  profileTab: {
    profilePicture: "Foto de Perfil",
    uploadNew: "Subir Nueva",
    remove: "Eliminar",
    uploading: "Subiendo...",
    uploadSuccess: "Avatar actualizado exitosamente",
    uploadError: "Error al subir. Por favor intenta de nuevo.",
    fileTooLarge: "Archivo demasiado grande. Max 5 MB.",
    unsupportedFileType: "Tipo de archivo no soportado. Usa JPEG, PNG o WebP.",
    basicInformation: "Informacion Basica",
    displayName: "Nombre para Mostrar",
    enterDisplayName: "Ingresa tu nombre para mostrar",
    username: "Nombre de Usuario",
    enterUsername: "Ingresa tu nombre de usuario",
    emailAddress: "Correo Electronico",
    enterEmail: "Ingresa tu correo electronico",
    addressInformation: "Informacion de Direccion",
    street: "Calle",
    enterStreet: "Ingresa tu direccion",
    street2: "Linea de Direccion 2",
    enterStreet2: "Apartamento, suite, etc. (opcional)",
    postalCode: "Codigo Postal",
    enterPostalCode: "Ingresa tu codigo postal",
    city: "Ciudad",
    enterCity: "Ingresa tu ciudad",
    stateProvince: "Estado / Provincia",
    enterStateProvince: "Ingresa tu estado o provincia",
    country: "Pais",
    selectCountry: "Selecciona tu pais",
    addressSaved: "Direccion actualizada exitosamente",
    addressSaveError: "Error al actualizar la direccion. Por favor intenta de nuevo.",
    savingAddress: "Guardando..."
  },
  privacyTab: {
    profileVisibility: "Visibilidad del Perfil",
    publicAnyone: "Publico - Cualquiera puede ver",
    followersOnly: "Solo Seguidores - Solo los seguidores pueden ver",
    privateOnly: "Privado - Solo tu puedes ver",
    showAchievements: "Mostrar Logros",
    showAchievementsDesc: "Muestra tus logros en tu perfil publico",
    allowMessages: "Permitir Mensajes",
    allowMessagesDesc: "Permite que otros traders te envien mensajes"
  },
  notificationsTab: {
    emailNotifications: "Notificaciones por Correo",
    emailNotificationsDesc: "Recibe actualizaciones importantes por correo electronico",
    notifications: "Notificaciones",
    pushNotifications: "Notificaciones Push",
    pushNotificationsDesc: "Recibe notificaciones en tiempo real en tu navegador",
    followerNotifications: "Notificaciones de Seguidores",
    followerNotificationsDesc: "Recibe notificacion cuando alguien te sigue",
    marketUpdates: "Actualizaciones de Mercado",
    marketUpdatesDesc: "Recibe noticias y actualizaciones importantes del mercado",
    achievementNotifications: "Notificaciones de Logros",
    achievementNotificationsDesc: "Recibe notificacion cuando desbloquees nuevos logros",
    emailFollowerNotifications: "Notificaciones de Seguidores por Correo",
    emailFollowerNotificationsDesc: "Recibe correos cuando alguien te sigue",
    emailMarketUpdates: "Actualizaciones de Mercado por Correo",
    emailMarketUpdatesDesc: "Recibe noticias y actualizaciones del mercado por correo electronico",
    emailAchievementNotifications: "Notificaciones de Logros por Correo",
    emailAchievementNotificationsDesc: "Recibe notificaciones de logros por correo electronico"
  },
  securityTab: {
    changePassword: "Cambiar Contrasena",
    changePasswordDesc: "Actualiza la contrasena de tu cuenta regularmente para mantenerla segura.",
    currentPassword: "Contrasena Actual",
    newPassword: "Nueva Contrasena",
    confirmNewPassword: "Confirmar Nueva Contrasena",
    atLeast8Characters: "Al menos 12 caracteres",
    uppercaseLetter: "Letra mayuscula",
    lowercaseLetter: "Letra minuscula",
    number: "Numero",
    specialCharacter: "Caracter especial",
    passwordsDoNotMatch: "Las contrasenas no coinciden.",
    hidePassword: "Ocultar contrasena",
    showPassword: "Mostrar contrasena",
    reset: "Reset",
    savePassword: "Guardar Contrasena",
    saving: "Guardando...",
    passwordChanged: "Contrasena cambiada exitosamente!",
    passwordChangeFailed: "Error al cambiar la contrasena. Por favor intenta de nuevo.",
    reenterPassword: "Vuelve a ingresar tu nueva contrasena"
  },
  twoFactor: {
    title: "Autenticacion de Dos Factores",
    description: "Agrega una capa extra de seguridad a tu cuenta.",
    authenticatorApp: "Aplicacion de Autenticacion",
    enabled: "Activo",
    disabled: "Inactivo",
    enabledDesc: "Tu cuenta esta protegida con autenticacion de dos factores.",
    disabledDesc: "Activa 2FA para agregar una capa extra de seguridad.",
    enable: "Activar",
    disable: "Desactivar",
    enabledSuccess: "La autenticacion de dos factores ha sido activada exitosamente!",
    disabledSuccess: "La autenticacion de dos factores ha sido desactivada.",
    disableFailed: "Error al desactivar la autenticacion de dos factores. Por favor intenta de nuevo.",
    setupTitle: "Configurar 2FA",
    setupSubtitle: "Protege tu cuenta con una aplicacion de autenticacion",
    setupFailed: "Error al iniciar la configuracion de 2FA. Por favor intenta de nuevo.",
    verifyFailed: "Verificacion fallida. Por favor verifica el codigo e intenta de nuevo.",
    step1Title: "Instala una Aplicacion de Autenticacion",
    step1Desc: "Descarga e instala una aplicacion de autenticacion en tu dispositivo movil. La usaras para generar codigos de verificacion.",
    recommendedApps: "Aplicaciones recomendadas:",
    continue: "Continuar",
    initializing: "Inicializando...",
    step2Title: "Escanea el Codigo QR",
    step2Desc: "Abre tu aplicacion de autenticacion y escanea este codigo QR.",
    manualEntry: "No puedes escanear? Ingresa esta clave manualmente:",
    step3Title: "Verificar Configuracion",
    step3Desc: "Ingresa el codigo de 6 digitos de tu aplicacion de autenticacion para completar la configuracion.",
    verificationCode: "Codigo de Verificacion",
    back: "Atras",
    activate: "Activar 2FA",
    verifying: "Verificando...",
    switchToEmail: "Cambiar a Correo Electronico"
  },
  comparisonSection: {
    badge: "Por que Nextproptrader?",
    title: "Somos",
    titleHighlight: "Diferentes",
    titleEnd: "De Otras Firmas de Prop",
    subtitle: "Descubre por que miles de traders eligen Nextproptrader sobre las firmas de prop trading tradicionales.",
    features: {
      profitSplit: "Reparto de Ganancias",
      payoutFrequency: "Frecuencia de Pagos",
      hiddenFees: "Costos Ocultos",
      platformQuality: "Calidad de Plataforma",
      miniMicroScaling: "Escalado Mini/Micro",
      evaluationTime: "Tiempo de Evaluacion"
    },
    nextprop: {
      profitSplit: "100%",
      payoutFrequency: "Diario",
      hiddenFees: "Transparencia",
      platformQuality: "Unica y en Vivo",
      miniMicroScaling: "Escala justa 1:10",
      evaluationTime: "Solo 5 Dias"
    },
    others: {
      profitSplit: "75-90%",
      payoutFrequency: "Semanal/Mensual",
      hiddenFees: "Multiples comisiones",
      platformQuality: "Basica/Limitada",
      miniMicroScaling: "1:1 desfavorable",
      evaluationTime: "10-30+ Dias"
    },
    table: {
      features: "Caracteristicas",
      featuresDesc: "Lo que mas importa",
      nextproptrader: "Nextproptrader",
      industryLeader: "LIDER DE LA INDUSTRIA",
      otherPropFirms: "Otras Firmas de Prop",
      industryStandard: "Estandar de la Industria"
    },
    summary: {
      title: "El Claro Ganador",
      description: "Nextproptrader supera consistentemente a otras firmas de prop en todas las metricas clave que importan a los traders."
    },
    benefits: {
      profitSplit: {
        title: "100% Reparto de Ganancias",
        description: "Quédate con todo lo que ganas. Sin recortes ni comisiones ocultas."
      },
      dailyPayouts: {
        title: "Pagos Diarios",
        description: "Accede a tus ganancias inmediatamente, no semanas despues."
      },
      transparentRules: {
        title: "Reglas Transparentes",
        description: "Reglas claras y justas sin restricciones sorpresa."
      },
      fastEvaluation: {
        title: "Evaluacion Rapida",
        description: "Obtiene financiacion en solo 5 dias de trading."
      }
    },
    cta: {
      title: "Listo para Experimentar la",
      titleHighlight: "Diferencia?",
      description: "Unete a miles de traders que han hecho el cambio a una mejor experiencia de prop trading.",
      button: "Comienza Tu Evaluacion"
    }
  },
  transparencySection: {
    badge: "Pura Transparencia",
    title: "Solo 2 Reglas Simples.",
    titleHighlight: "Sin Trampas Ocultas.",
    subtitle: "Mientras otras firmas de prop te entierran en regulaciones complejas para evitar pagarte, nosotros lo mantenemos radicalmente simple. Dos reglas de consistencia claras en funded — eso es todo.",
    others: {
      title: "Otras Firmas de Prop",
      subtitle: "Reglas complejas disenadas para hacerte fallar",
      rule1: "Reglas de consistencia complejas que cambian sin previo aviso",
      rule2: "Eliminacion de cuenta despues de solo 6 pagos — empezar desde cero",
      rule3: "Restricciones ocultas que solo aparecen cuando solicitas un pago",
      rule4: "Sistemas de reglas elaborados disenados para hacer los pagos casi imposibles",
      rule5: "Nuevas reglas aplicadas retroactivamente a cuentas existentes"
    },
    us: {
      title: "Nextproptrader",
      subtitle: "Solo 2 reglas claras en funded",
      rule1: "Regla Lucky Punch: Ningun trade individual puede superar el 30% del PnL total",
      rule2: "Plan de Escalado: Cada $2,500 desbloquea un contrato adicional",
      rule3: "Eso es todo. Sin reglas ocultas, sin sorpresas, sin letra pequena",
      conclusion: "Dos reglas. Transparencia total. Tu exito es lo unico que importa."
    },
    rules: {
      luckyPunch: {
        title: "Regla Lucky Punch",
        description: "Tu mayor trade individual no debe superar el 30% de tu ganancia total. Esto asegura que construyas un rendimiento consistente — sin depender de un golpe de suerte.",
        exampleTitle: "Ejemplo Practico",
        example: {
          passLabel: "Cumple",
          passText: "PnL Total: $5,000. Mayor trade: $1,200 (24%). Esta bien dentro del limite del 30% — trading consistente, sin problemas.",
          failLabel: "No Cumple",
          failText: "PnL Total: $3,000. Mayor trade: $1,500 (50%). Un trade representa mas del 30% — esto indica un golpe de suerte en lugar de trading consistente.",
          note: "Esta regla simplemente asegura que tus ganancias provienen de habilidad consistente, no de un unico trade excepcional. Protege tanto a ti como a la firma."
        }
      },
      scalingPlan: {
        title: "Plan de Escalado",
        description: "Comienzas con un numero base de contratos. Por cada $2,500 de ganancia, desbloqueas un contrato adicional. Esto asegura que escales tu trading de forma segura junto con tu cuenta en crecimiento.",
        exampleTitle: "Ejemplo Practico",
        example: {
          passLabel: "Ejemplo de Progresion",
          passText: "Empiezas con 1 contrato. Despues de ganar $2,500 puedes operar con 2 contratos. Despues de $5,000 de ganancia total desbloqueas 3 contratos — y asi sucesivamente, paso a paso.",
          failLabel: "Lo Que No Funciona",
          failText: "Intentar operar con 5 contratos el primer dia con una cuenta funded nueva. El plan de escalado asegura que aumentes tu tamano gradualmente a medida que tus ganancias demuestran que estas listo.",
          note: "El plan de escalado protege tu cuenta de riesgo excesivo en las etapas iniciales. A medida que crecen tus ganancias, naturalmente crece tu capacidad de trading."
        }
      }
    },
    showExample: "Ver Ejemplo",
    hideExample: "Ocultar Ejemplo",
    bottom: {
      title: "Sin Letra Pequena.",
      titleHighlight: "Solo Trading Justo.",
      description: "Mientras los competidores inventan nuevas reglas para evitar pagarte, nosotros te damos exactamente dos reglas de consistencia simples. Todo lo demas esta en tus manos. Opera a tu manera — cobra a tu manera."
    }
  },
  platformSection: {
    badge: "NEXTPROPTRADER",
    title: "Por que los Prop Traders",
    titleHighlight: "Nos Eligen",
    subtitle: "Desde pagos consistentes hasta un modelo real basado en trading, ofrecemos la infraestructura, el soporte y la vision que los traders serios necesitan para tener exito.",
    features: {
      reliablePayouts: {
        title: "Pagos Confiables",
        description: "A diferencia de muchas firmas que inventan excusas para retener tus ganancias, nosotros nunca hemos fallado un pago. Punto. Cobra de forma fiable via transferencia bancaria, PayPal o cripto - sin retrasos, sin drama."
      },
      technology: {
        title: "Tecnologia Lider en la Industria",
        description: "Desde la conectividad hasta nuestro panel de trader, nuestra tecnologia esta entre las mas avanzadas de la industria. Innovamos constantemente para estar un paso adelante, dandote la velocidad, estabilidad y herramientas que necesitas para rendir."
      },
      partnerships: {
        title: "Alianzas a Largo Plazo",
        description: "No buscamos evaluaciones unicas, estamos aqui para construir relaciones a largo plazo. A traves de nuestro programa, los traders exitosos obtienen acceso a oportunidades exclusivas y mayor escala de capital con el tiempo."
      },
      builtToTrade: {
        title: "Construido para Operar - No Solo para Vender",
        description: "A diferencia de las firmas de prop de descuento que sobreviven solo con las comisiones de evaluacion, operamos infraestructura real que prospera con el rendimiento de trading real. Nuestro modelo de negocio esta alineado con tu exito, porque crecemos cuando tu creces."
      }
    },
    profitSplit: {
      title: "Reparto de Ganancias",
      subtitle: "Lider en la Industria",
      badge: "LIDER EN LA INDUSTRIA",
      keepEverything: "Te Quedas con Todo lo que Ganas"
    },
    explanation: {
      title: "Por que 100% de Reparto de Ganancias?",
      believeInSuccess: "Creemos en tu exito.",
      paragraph1: "A diferencia de las firmas de prop tradicionales que toman el 10-20% de tus ganancias, te dejamos quedarte con el 100% de lo que ganas porque tus habilidades de trading merecen la recompensa completa.",
      paragraph2: "No tomamos nada, porque escalamos contigo. Cuando estas financiado y rindes bien, replicamos tus operaciones en segundo plano con posiciones mas grandes. Te quedas con el 100% de tus ganancias, nosotros ganamos escalando tu ventaja. Un modelo ganar-ganar construido sobre confianza y rendimiento."
    },
    benefits: {
      hiddenFees: {
        value: "$0",
        label: "Costos Ocultos"
      },
      earningPotential: {
        value: "∞",
        label: "Potencial de Ganancias"
      }
    }
  },
  tradingActivity: {
    title: "Actividad de Trading",
    subtitle: "Rendimiento en Vivo",
    description: "Rendimiento de trading y analiticas en tiempo real"
  },
  recentTrades: {
    title: "Operaciones de Hoy",
    subtitle: "Ultima actividad de trading",
    quantity: "Lots",
    entry: "Entrada",
    current: "Actual",
    exit: "Salida",
    pnl: "P&L",
    duration: "Duracion",
    running: "En curso",
    open: "Abierta",
    closed: "Cerrada",
    winners: "Ganadoras",
    losers: "Perdedoras",
    tradedLots: "Lots Operados",
    avgNetPnL: "P&L Neto Prom.",
    noTrades: "Sin Operaciones Hoy",
    noTradesDesc: "No se han ejecutado operaciones hoy"
  },
  pnlCalendar: {
    title: "Calendario de P&L",
    subtitle: "Resumen de rendimiento diario",
    allAccounts: "Todas las Cuentas",
    totalPnl: "P&L Total",
    totalTrades: "Operaciones",
    winDays: "Dias Ganadores",
    lossDays: "Dias Perdedores",
    days: {
      sun: "Dom",
      mon: "Lun",
      tue: "Mar",
      wed: "Mie",
      thu: "Jue",
      fri: "Vie",
      sat: "Sab"
    }
  },
  panelSwitcher: {
    performance: "Rendimiento",
    trades: "Operaciones"
  },
  dailyPerformanceChart: {
    title: "Grafico de Rendimiento",
    subtitle: "Ultimos 14 Dias de Trading",
    today: "hoy",
    dailyPnL: "P&L Diario",
    tradePnL: "P&L por Operacion",
    bestDay: "Mejor Dia",
    bestTrade: "Mejor Operacion",
    avgDaily: "Promedio Diario",
    avgPnLToday: "P&L Prom. Hoy",
    last14Days: "ultimos 14 dias",
    worstDay: "Peor Dia",
    worstTrade: "Peor Operacion",
    trades: "operaciones",
    tradingDays: "Dias de Trading",
    perDay: "por dia"
  },
  accountPerformance: {
    title: "Rendimiento de la Cuenta",
    subtitle: "Todas las cuentas de trading",
    leading: "Liderando",
    since: "Desde",
    noData: "No hay datos disponibles",
    account: "Cuenta",
    startBalance: "Saldo Inicial",
    balance: "Saldo",
    netPnL: "P&L Neto",
    performance: "Rendimiento",
    todaysPnL: "P&L de Hoy"
  },
  todaysSession: {
    title: "Sesion de Hoy",
    livePerformance: "Rendimiento en vivo",
    active: "Activa",
    totalTrades: "Total de Operaciones",
    sessionPnL: "P&L de la Sesion",
    winRate: "Tasa de Acierto",
    winningTrades: "Operaciones Ganadoras",
    losingTrades: "Operaciones Perdedoras",
    avgWin: "Ganancia Prom.",
    avgLoss: "Perdida Prom.",
    largestWin: "Mayor Ganancia",
    largestLoss: "Mayor Perdida",
    avgTradeDuration: "Duracion Prom. de Operacion",
    sessionSummary: "Resumen de la Sesion"
  },
  controlPanel: {
    title: "Panel de Control",
    subtitle: "Gestion de operaciones",
    live: "En Vivo",
    openPositions: "Posiciones Abiertas",
    active: "activas",
    noOpenPositions: "Sin posiciones abiertas",
    quickActions: "Acciones Rapidas",
    closeAllPositions: "Cerrar Todas las Posiciones",
    closingPositions: "Cerrando posiciones...",
    close: "Cerrar",
    closing: "Cerrando...",
    confirmCloseAll: "Cerrar Todas las Posiciones?",
    confirmMessage: "Estas seguro de que quieres cerrar todas las {count} posiciones abiertas?",
    cancel: "Cancelar",
    closeAll: "Cerrar Todo"
  },
  addAccountModal: {
    title: "Agregar Nueva Cuenta",
    subtitle: "Elige tu cuenta de evaluacion",
    mostPopular: "MAS POPULAR",
    tradingCapital: "Capital de Trading",
    only: "Solo",
    per30Days: "/30 dias",
    getAccess: "Obtiene acceso a",
    capital: "de capital",
    startEvaluation: "INICIAR EVALUACION",
    allPlansInclude: "Todos los Planes Incluyen",
    fullPlatformAccess: "Acceso Completo a la Plataforma",
    completeAccess: "Acceso completo a todas las herramientas de trading",
    level2MarketData: "Datos de Mercado Nivel 2",
    chooseDataFeed: "Elige tu fuente de datos preferida",
    premiumSupport: "Soporte Premium",
    professionalSupport: "Soporte profesional de trading 24/7"
  },
  footer: {
    traderFunding: "Financiacion de traders",
    description: "Ayudamos a los traders a monetizar su rendimiento simulado a traves de programas de financiacion, herramientas de nivel profesional y entornos de trading reales, sin arriesgar capital personal.",
    newsletter: {
      title: "Ofertas Exclusivas y Descuentos Limitados",
      description: "Se el primero en conocer ofertas por tiempo limitado y descuentos exclusivos para traders.",
      placeholder: "Ingresa tu correo electronico",
      subscribe: "Suscribirse Gratis",
      privacy: "Sin spam. Cancela cuando quieras. Tus datos estan protegidos.",
      subscribing: "Suscribiendo...",
      successMessage: "Por favor revisa tu correo y confirma tu suscripcion.",
      errorMessage: "Algo salio mal. Por favor intenta de nuevo.",
      invalidEmail: "Por favor ingresa un correo electronico valido.",
      confirm: {
        title: "Confirma Tu Suscripcion",
        subtitle: "Confirmacion de Newsletter",
        confirming: "Confirmando tu suscripcion...",
        success: "Tu suscripcion ha sido confirmada exitosamente!",
        successDetail: "Ahora recibiras nuestras ultimas ofertas y descuentos exclusivos directamente en tu bandeja de entrada.",
        error: "La confirmacion fallo. El enlace puede ser invalido o haber expirado.",
        backToHome: "Volver a la Pagina Principal"
      },
      unsubscribe: {
        title: "Cancelar Suscripcion al Newsletter",
        subtitle: "Preferencias de Newsletter",
        description: "Estas seguro de que quieres cancelar tu suscripcion a nuestro newsletter? Ya no recibiras ofertas exclusivas y descuentos.",
        button: "Cancelar Suscripcion",
        unsubscribing: "Cancelando suscripcion...",
        success: "Te has dado de baja exitosamente.",
        successDetail: "Ya no recibiras correos de newsletter de nuestra parte.",
        error: "La cancelacion fallo. El enlace puede ser invalido o haber expirado.",
        backToHome: "Volver a la Pagina Principal"
      }
    },
    ourProgram: {
      title: "Nuestro Programa",
      fundingProcess: "El Proceso de Financiacion",
      softwareSolution: "Nuestra Solucion de Software",
      profitSplit: "100% Reparto de Ganancias",
      pricing: "Nuestros Precios"
    },
    association: {
      title: "Asociacion",
      partnership: "Alianza",
      whiteLabel: "White Label",
      affiliateProgram: "Programa de Affiliate"
    },
    support: {
      title: "Soporte",
      faq: "Preguntas Frecuentes",
      contact: "Contacto"
    },
    copyright: "© {year} Nextproptrader LLC. Todos los derechos reservados.",
    privacyPolicy: "Politica de Privacidad",
    termsOfService: "Terminos de Servicio",
    disclaimers: {
      generalDisclosure: {
        title: "Divulgacion General",
        content: "Los materiales y contenido proporcionados por Nextproptrader LLC, ya sea en nuestro sitio web, a traves de documentos distribuidos u otras comunicaciones, estan destinados unicamente a fines informativos generales. Este contenido no constituye asesoramiento de inversion, una oferta de compra o venta de valores, ni un respaldo de instrumentos financieros, empresas o fondos. Los usuarios no deben interpretar la informacion como asesoramiento financiero personalizado. La informacion proporcionada no esta dirigida a ninguna jurisdiccion especifica y no debe usarse de ninguna manera que contravenga las leyes o regulaciones locales. Nextproptrader LLC, una entidad registrada en Business Center 1, M Floor, Meydan Grand Stand, Dubai, EAU, cumple con todas las leyes locales, estatales y federales relevantes. © {year}. Todos los derechos reservados."
      },
      riskDisclosure: {
        title: "Divulgacion de Riesgos",
        content: "El trading de futuros, forex y otros productos apalancados implica un riesgo sustancial de perdida y no es adecuado para todos los inversores. El rendimiento pasado no es necesariamente indicativo de resultados futuros. Debe considerar cuidadosamente si el trading es adecuado para usted a la luz de sus circunstancias, conocimientos y recursos financieros. Puede perder todo o mas de su inversion inicial. Las opiniones, datos de mercado y recomendaciones estan sujetos a cambios en cualquier momento. Nextproptrader no es un asesor de inversiones registrado y no proporciona asesoramiento de inversion. Todas las decisiones de trading son tomadas por el trader individual."
      },
      hypotheticalPerformance: {
        title: "Divulgacion de Rendimiento Hipotetico",
        content: "Los resultados de rendimiento hipotetico tienen muchas limitaciones inherentes. No se esta haciendo ninguna representacion de que alguna cuenta lograra o es probable que logre ganancias o perdidas similares a las mostradas. De hecho, frecuentemente hay diferencias marcadas entre los resultados de rendimiento hipotetico y los resultados reales logrados posteriormente por cualquier programa de trading en particular. Una de las limitaciones de los resultados de rendimiento hipotetico es que generalmente se preparan con el beneficio de la retrospectiva. Ademas, el trading hipotetico no implica riesgo financiero, y ningun registro de trading hipotetico puede dar cuenta completamente del impacto del riesgo financiero en el trading real. La capacidad de soportar perdidas o de adherirse a un programa de trading en particular a pesar de las perdidas son puntos materiales que tambien pueden afectar adversamente los resultados reales de trading."
      },
      finalNotice: "Este sitio web y su contenido son solo para fines informativos. El trading implica riesgo y puede no ser adecuado para todos los inversores. Por favor lea todas las divulgaciones de riesgo antes de operar. Nextproptrader LLC no es responsable de ninguna perdida de trading incurrida por los usuarios de esta plataforma."
    },
    systemStatus: {
      title: "Estado del Sistema",
      subtitle: "Monitoreo de la plataforma en tiempo real",
      allSystemsOperational: "Todos los Sistemas Operativos",
      platformRunning: "La plataforma funciona correctamente",
      overallUptime: "Tiempo de Actividad General",
      coreSystems: "Sistemas Principales",
      marketDataFeeds: "Fuentes de Datos de Mercado",
      operational: "Operativo",
      maintenance: "Mantenimiento",
      uptime: "Tiempo de Actividad",
      responseTime: "Tiempo de Respuesta",
      latency: "Latencia",
      statusUpdates: "Actualizaciones de Estado",
      lastUpdated: "Ultima actualizacion",
      refreshes: "Se actualiza cada 30 segundos",
      liveMonitoring: "Monitoreo en Vivo",
      systems: {
        tradingPlatform: {
          name: "Plataforma de Trading",
          description: "Infraestructura principal de trading"
        },
        userDashboard: {
          name: "Panel de Usuario",
          description: "Sistema de gestion de cuentas"
        },
        paymentSystem: {
          name: "Sistema de Pagos",
          description: "Procesamiento de pagos"
        },
        apiServices: {
          name: "Servicios API",
          description: "Integraciones de terceros"
        }
      },
      dataFeeds: {
        rithmic: "Datos de mercado de futuros",
        dxfeed: "Datos de mercado multi-activo"
      }
    }
  },
  hero: {
    badge: "Nextproptrader 2.0 – Prop trading, redefinido.",
    headline1: "Tus Operaciones.",
    headline2: "Nuestro Capital.",
    headline3: "Ganancias Reales.",
    description: "Con nosotros, puedes monetizar tu sim trading, completamente sin riesgo. Opera en un entorno seguro y recibe",
    profitSplit: "el 100% de tus ganancias",
    descriptionEnd: ". Sin estres, solo tus habilidades convertidas en ganancias reales.",
    getFundedButton: "Obtiene Financiacion Ahora",
    learnMoreButton: "Saber Mas",
    stats: {
      capitalAllocated: "En Capitalizaciones",
      capitalSubtitle: "Capital Financiado",
      fundedAccounts: "Cuentas Financiadas",
      accountsSubtitle: "Confianza de Miles",
      tradesExecuted: "Operaciones Ejecutadas",
      tradesSubtitle: "Millones de Ideas. Una Plataforma."
    },
    dashboard: {
      title: "Panel",
      subtitle: "Entorno de Trading en Vivo",
      fundedBadge: "Financiada",
      accountBalance: "Saldo de la Cuenta",
      todayPerformance: "hoy",
      possiblePayout: "Pago Posible",
      payoutButton: "Pago",
      profitSplit: "100%",
      profitSplitLabel: "Reparto de Ganancias",
      instrument: "NQ1! Futures",
      liveData: "Datos en Vivo",
      todayProfit: "hoy"
    }
  },
  header: {
    process: "Proceso",
    pricing: "Precios",
    payouts: "Pagos",
    contact: "Contacto",
    login: "Iniciar Sesion",
    register: "Registrarse",
    getStarted: "Registrarse",
    backToMainSite: "Volver al Sitio Principal"
  },
  logoutModal: {
    title: 'Cerrando Sesion',
    subtitle: 'Por favor espera mientras cerramos tu sesion de forma segura',
    loggingOut: 'Cerrando sesion...',
    securityMessage: 'Estamos limpiando tu sesion de forma segura y protegiendo los datos de tu cuenta.'
  },
  loginModal: {
    welcomeBack: "Bienvenido de Nuevo",
    signInToAccount: "Inicia sesion en tu cuenta",
    resetPassword: "Iniciar Sesion",
    enterEmailToReset: "Restablecer Contrasena",
    resetInstructions: "Ingresa tu correo electronico para restablecer tu contrasena",
    resetLinkSent: "Por favor revisa tu correo",
    sendingResetLink: "El enlace sera enviado...",
    emailAddress: "Correo Electronico",
    enterYourEmail: "Ingresa tu correo",
    emailOrUsername: "Correo o nombre de usuario",
    enterEmailOrUsername: "Ingresa tu correo o nombre de usuario",
    password: "Contrasena",
    enterYourPassword: "Ingresa tu contrasena",
    rememberMe: "Recordarme",
    forgotPassword: "Olvidaste tu contrasena?",
    signIn: "Iniciar Sesion",
    enterEmailAddress: "Ingresa tu correo electronico",
    resetLinkInfo: "Te enviaremos un enlace seguro para restablecer tu contrasena. Por favor revisa tu bandeja de entrada y carpeta de spam.",
    sendResetLink: "Enviar Enlace de Restablecimiento",
    resendInSeconds: "Reenvio disponible en {s}s",
    backToLogin: "← Volver a Iniciar Sesion",
    or: "o",
    dontHaveAccount: "No tienes una cuenta?",
    createOneNow: "Crea una ahora",
    signingIn: "Iniciando sesion...",
    enterSecurityCode: "Codigo de Seguridad",
    enterCodeFromApp: "Autenticacion OTP",
    enterCodeFromEmail: "Ingresa el codigo enviado a tu correo",
    securityCode: "Ingresa el codigo:",
    verifyAndSignIn: "Iniciar Sesion",
    verifying: "Verificando",
    resetError: "Ocurrio un error. Por favor intenta de nuevo.",
    setNewPassword: "Nueva Contrasena",
    enterNewPasswordSubtitle: "Establece tu nueva contrasena",
    newPasswordInstructions: "Por favor ingresa tu nueva contrasena. Debe tener al menos 8 caracteres.",
    newPassword: "Nueva Contrasena",
    enterNewPassword: "Ingresa tu nueva contrasena",
    confirmPassword: "Confirmar Contrasena",
    repeatNewPassword: "Repite tu nueva contrasena",
    passwordsMismatch: "Las contrasenas no coinciden.",
    passwordTooShort: "La contrasena debe tener al menos 12 caracteres y contener un numero y un caracter especial.",
    resettingPassword: "Guardando...",
    saveNewPassword: "Guardar Nueva Contrasena",
    passwordResetSuccess: "Contrasena Cambiada",
    passwordResetSuccessMessage: "Tu contrasena ha sido restablecida exitosamente. Ahora puedes iniciar sesion con tu nueva contrasena.",
    backToLoginButton: "Volver a Iniciar Sesion",
    loginFailed: "Inicio de sesion fallido. Por favor verifica tu correo/nombre de usuario y contrasena.",
    accountBlocked: "Tu cuenta ha sido bloqueada. Por favor contacta al soporte en support@nextproptrader.com"
  },
  evaluationProcess: {
    badge: "Tu Camino Hacia la Financiacion",
    title: "Proceso de",
    titleHighlight: "4 Pasos",
    titleEnd: "de Evaluacion Simple",
    subtitle: "Nuestro proceso de evaluacion simplificado esta disenado para identificar traders talentosos y financiarlos rapidamente.",
    steps: {
      step1: {
        title: "Inicia Tu Evaluacion",
        subtitle: "Comienza a operar",
        description: "Elige el tamano de tu cuenta y comienza a operar con nuestro capital simulado. Sin riesgo para tu propio dinero.",
        duration: "Dia 1",
        requirement: "Configuracion de Cuenta"
      },
      step2: {
        title: "Alcanza el Objetivo de Ganancia",
        subtitle: "Demuestra tus habilidades",
        description: "Alcanza tu objetivo de ganancia mientras sigues nuestras reglas de gestion de riesgo. Demuestra un rendimiento de trading consistente.",
        duration: "5-30 dias",
        requirement: "6-8% Objetivo de Ganancia"
      },
      step3: {
        title: "Gestion de Riesgo",
        subtitle: "Mantente dentro de los limites",
        description: "Manten una gestion de riesgo adecuada durante toda la evaluacion. Nunca excedas los limites maximos de drawdown.",
        duration: "Continuo",
        requirement: "Drawdown Maximo"
      },
      step4: {
        title: "Obtiene Financiacion",
        subtitle: "Recibe capital real",
        description: "Felicidades! Has aprobado la evaluacion y ahora recibes acceso a tu cuenta financiada.",
        duration: "En minutos",
        requirement: "Activacion de Cuenta"
      }
    },
    stepContent: {
      step1: {
        chooseCapital: "Elige Capital",
        availableRange: "$10K - $250K disponibles",
        startTrading: "Comienza a Operar",
        beginImmediately: "Comienza inmediatamente"
      },
      step2: {
        profitTargetProgress: "Progreso del Objetivo de Ganancia",
        ofAmount: "de $50K = $3,000"
      },
      step3: {
        riskManagement: "Gestion de Riesgo",
        withinLimits: "✓ Dentro de los Limites",
        maxDrawdown: "Drawdown Maximo",
        dependsOnAccount: "depende del tamano de la cuenta"
      },
      step4: {
        congratulations: "Felicidades!",
        accountPreparing: "Tu cuenta financiada esta siendo preparada"
      }
    },
    rules: {
      title: "Reglas de",
      titleHighlight: "Evaluacion",
      subtitle: "Reglas simples y transparentes para el exito de tu evaluacion",
      rule1: {
        title: "Financiacion en 5 Dias",
        description: "Obtiene financiacion despues de 5 dias de trading y no hay maximo tampoco. Puedes tomarte todo el tiempo que necesites."
      },
      rule2: {
        title: "Tamano Maximo de Lots",
        description: "No excedas el numero maximo de lots permitidos para ti. Cada cuenta tiene un limite diferente."
      },
      rule3: {
        title: "Limite Maximo de Perdida",
        description: "Limita tu riesgo y opera de manera efectiva. No debes caer por debajo del drawdown dinamico."
      },
      rule4: {
        title: "Horarios de Trading",
        description: "Debes cerrar todas las posiciones a las 3:15 PM CST como maximo. El trading se reanuda a las 5:00 PM CST."
      }
    }
  },
  solutions: {
    badge: "Empoderando Traders Con Precision Propietaria",
    title: "Construido para",
    titleHighlight: "Prop Trading",
    titleEnd: "Profesional",
    subtitle: "Nuestra plataforma profesional proporciona las herramientas e infraestructura que los prop traders necesitan para tener exito en los mercados de futuros actuales.",
    poweredBy: "Impulsado por:",
    premiumDataFeeds: {
      title: "Fuentes de Datos Premium",
      description: "Datos profesionales de mercado CME de proveedores lideres en la industria con ejecucion en tiempo real.",
      dataPartners: "Nuestros Socios de Datos:",
      subtitle: "Datos en Tiempo Real Nivel 2",
      badge: "Datos de Mercado CME"
    },
    dailyPayouts: {
      title: "Pagos Diarios",
      description: "Opciones de pago rapidas y flexibles con retiros diarios a traves de multiples metodos de pago.",
      badge: "Rapido y Flexible",
      features: {
        dailyWithdrawals: "Retiros diarios",
        bankTransfer: "Transferencia bancaria",
        paypalCrypto: "PayPal y Cripto"
      }
    },
    payoutMethods: {
      bank: "Banco",
      transfer: "Transferencia",
      paypal: "PayPal",
      payments: "Pagos",
      crypto: "Cripto",
      downloadReceipt: "Descargar Recibo"
    },
    payoutDemo: {
      approved: "PAGO APROBADO",
      paid: "PAGADO",
      amount: "Monto del Pago",
      date: "Fecha:",
      to: "Para:",
      method: "Metodo:",
      account: "Cuenta:",
      congratulations: "Felicidades por tu pago!",
      fundsTransferred: "Tus fondos han sido transferidos exitosamente a tu cuenta."
    }
  },
  platformShowcase: {
    badge: "Una Plataforma. Todas las Herramientas. Sin Limites.",
    title: "Centro de Trading",
    titleHighlight: "Todo en Uno",
    titleEnd: "para Prop Traders",
    subtitle: "Todo tu trading. Un panel inteligente. Analiza, gestiona y ejecuta - mas rapido, mas claro, mejor.",
    platform: {
      dashboard: "Panel",
      subtitle: "Interfaz unificada",
      badge: "NXT Hub 2.0",
      liveData: "Datos en Vivo",
      currentSlideTitle: "Suite Avanzada de Graficos"
    },
    features: {
      security: "Seguridad de Grado Bancario",
      securityDesc: "Encriptacion de 256 bits",
      execution: "Ejecucion Ultra Rapida",
      executionDesc: "Sub-milisegundo",
      indicators: "100+ Indicadores",
      indicatorsDesc: "Analisis tecnico",
      awardWinning: "Galardonada",
      awardWinningDesc: "Lider de la industria"
    },
    floating: {
      realTimeData: "Datos de Mercado en Tiempo Real",
      advancedAnalytics: "Analiticas Avanzadas",
      lightningExecution: "Ejecucion Relampago",
      uptime: "Tiempo de Actividad",
      latency: "Latencia",
      support: "Soporte"
    }
  },
  pricingSection: {
    badge: "Elige Tu Capital de Trading",
    title: "Comienza a Operar con",
    titleHighlight: "Nuestro Capital",
    subtitle: "Elige el tamano de cuenta perfecto para tu estilo de trading. Todos los planes incluyen acceso completo a la plataforma y soporte profesional.",
    mostPopular: "Mas popular",
    tradingCapital: "Capital de Trading",
    only: "Solo",
    month: "mes",
    per30Days: "/{{days}} dias",
    getAccess: "Obtiene acceso a {{capital}} de capital",
    getFunded: "OBTENER FINANCIACION",
    allPlansInclude: "Todos los Planes Incluyen",
    fullPlatformAccess: "Acceso Completo a la Plataforma",
    completeAccess: "Acceso completo a todas las herramientas de trading",
    level2MarketData: "Datos de Mercado Nivel 2",
    chooseDataFeed: "Elige tu fuente de datos preferida",
    premiumSupport: "Soporte Premium",
    professionalSupport: "Soporte profesional de trading 24/7",
    minTradingDays_one: "Min. {{days}} Dia de Trading",
    minTradingDays_other: "Min. {{days}} Dias de Trading",
    profitSplit: "{{split}}% Reparto de Ganancias",
    maxLots_one: "Max. {{lots}} Lot ({{micros}} Micros)",
    maxLots_other: "Max. {{lots}} Lots ({{micros}} Micros)",
    profitTarget: "${{target}} Objetivo de Ganancia",
    maxLoss: "${{loss}} Perdida Max.",
    loadingProducts: "Cargando productos...",
    errorLoading: "Error al cargar productos",
    noProducts: "No hay productos disponibles"
  },
  testimonials: {
    badge: "Pagos Verificados",
    title: "Miles de Traders Pagados.",
    titleHighlight: "Millones Verificados.",
    titleEnd: "Confianza Ganada.",
    subtitle: "Traders reales, ganancias reales, pagos reales. Ve los certificados de nuestros traders financiados en todo el mundo.",
    certificate: {
      title: "Certificado de Pago",
      fundedAccount: "Cuenta Financiada",
      account: "Cuenta",
      trader: "Trader",
      payout: "Pago",
      certificateId: "ID de Certificado",
      paid: "PAGADO"
    }
  },
  purchaseModal: {
    title: "Completar Compra",
    subtitle: "Proceso de pago seguro",
    resetSubtitle: "Reiniciar saldo y estadisticas de la cuenta",
    resetDescription: "Reinicia las estadisticas y el saldo de tu cuenta. Ten en cuenta que este producto no extiende el plazo de tu cuenta de trading.",
    extensionDescription: "Este producto extiende tu cuenta de trading por 30 dias adicionales. No tiene efecto en tus estadisticas de trading.",
    fundedFeeDescription: "Esta es la cuota de activacion para tu nueva cuenta Financiada y cualquier cuenta Financiada adicional activada durante este periodo.",
    personalInformation: "Informacion Personal",
    personalInfoDescription: "Por favor proporciona tus datos personales",
    firstName: "Nombre",
    lastName: "Apellido",
    enterFirstName: "Ingresa tu nombre",
    enterLastName: "Ingresa tu apellido",
    emailAddress: "Correo Electronico",
    enterEmail: "Ingresa tu correo electronico",
    country: "Pais",
    countryOrRegion: "Pais o region",
    selectCountry: "Selecciona tu pais",
    searchCountries: "Buscar paises...",
    noCountriesFound: "No se encontraron paises",
    streetAddress: "Direccion",
    address: "Direccion",
    enterStreetAddress: "Ingresa tu direccion",
    postalCode: "Codigo Postal",
    enterPostalCode: "Ingresa tu codigo postal",
    city: "Ciudad",
    enterCity: "Ingresa tu ciudad",
    challenge: "Evaluacion",
    profitTarget: "Objetivo de Ganancia",
    maxDailyLoss: "Perdida Diaria Maxima",
    maxTotalLoss: "Perdida Total Maxima",
    maxLoss: "Perdida Maxima",
    profitSplit: "Reparto de Ganancias",
    minTradingDays: "Min. Dias de Trading",
    maxLots: "Max Contratos",
    continue: "Continuar",
    continueToPayment: "Continuar al Pago",
    personal: "Personal",
    payment: "Pago",
    paymentDetails: "Detalles del Pago",
    paymentInformation: "Informacion de Pago",
    securePayment: "Procesamiento de pago seguro",
    paymentMethod: "Metodo de Pago",
    currency: "Moneda",
    card: "Tarjeta",
    cardNumber: "Numero de tarjeta",
    enterCardNumber: "1234 5678 9012 3456",
    expiration: "Vencimiento",
    enterExpiry: "MM/AA",
    cvv: "CVV",
    enterCvv: "123",
    fullName: "Nombre completo",
    cardholderName: "Nombre del Titular",
    enterCardholderName: "Juan Perez",
    creditCard: "Tarjeta de Credito",
    expiryDate: "Fecha de Vencimiento",
    securePaymentTitle: "Pago Seguro",
    securePaymentDescription: "Tu informacion de pago esta encriptada y segura.",
    paypal: "PayPal",
    paypalEmail: "Correo de PayPal",
    enterPaypalEmail: "tu.correo@ejemplo.com",
    paypalPayment: "Pago con PayPal",
    paypalRedirectDescription: "Seras redirigido a PayPal para completar tu pago",
    stripeRedirectDescription: "Seras redirigido a Stripe para completar tu pago de forma segura",
    bitpayRedirectDescription: "Seras redirigido a BitPay para completar tu pago con criptomoneda de forma segura",
    soon: "Pronto",
    crypto: "Cripto",
    cryptocurrency: "Criptomoneda",
    cryptoPayment: "Pago con Criptomoneda",
    selectCryptocurrency: "Seleccionar Criptomoneda",
    cryptoInstructions: "Recibiras instrucciones de pago para {cryptoType} despues de la confirmacion del pedido",
    cryptoImportantNote: "Por favor asegurate de enviar el monto exacto a la direccion proporcionada",
    termsAndConditions: "Acepto los terminos y condiciones y la politica de privacidad",
    reviewConfirm: "Revisar y Confirmar",
    reviewConfirmDescription: "Por favor revisa tu pedido antes de completar",
    orderSummary: "Resumen del Pedido",
    product: "Producto",
    price: "Precio",
    productDiscount: "Descuento del Producto",
    discountedPrice: "Precio con Descuento",
    coupon: "Cupon",
    finalPrice: "Precio Final",
    couponCode: "Codigo de Cupon",
    enterCouponCode: "Ingresa el codigo de cupon",
    applyCoupon: "Aplicar",
    couponHelp: "Ingresa un codigo de cupon valido para obtener un descuento",
    couponApplied: "Cupon Aplicado",
    applied: "Aplicado",
    percentDiscountApplied: "{percent}% de descuento aplicado",
    amountDiscountApplied: "€{amount} de descuento aplicado",
    selectDataFeed: "Seleccionar Fuente de Datos",
    targetAccount: "Cuenta Destino",
    agreeToTerms: "Acepto los",
    termsOfService: "Terminos de Servicio",
    and: "y",
    privacyPolicy: "Politica de Privacidad",
    noRefundPolicy: "Todas las ventas son finales - sin reembolsos",
    previous: "Anterior",
    nextStep: "Siguiente Paso",
    review: "Revisar",
    completePurchase: "Completar Compra",
    processing: "Procesando...",
    processingPayment: "Procesando Pago...",
    purchaseSuccessful: "Compra Exitosa!",
    purchaseSuccessMessage: "Tu cuenta ha sido creada y esta lista para usar.",
    redirecting: "Redirigiendo...",
    paymentRedirectTitle: "Pagina de pago abierta",
    paymentRedirectMessage: "La pagina de pago ha sido abierta en una nueva pestana. Por favor completa tu pago alli.",
    paymentRedirectCloseHint: "Despues de completar el pago puedes cerrar esta ventana.",
    paymentRedirectOpenAgain: "Abrir enlace de pago de nuevo",
    paymentRedirectClose: "Cerrar esta ventana",
    accountCreated: "Tu cuenta ha sido creada y estara disponible dentro de 24 horas",
    subscriptionDisclaimer: "Al crear tu suscripcion, permites que {productName} cargue tu tarjeta por este pago y pagos futuros de acuerdo con sus terminos. Siempre puedes cancelar tu suscripcion.",
    quantity: "Cantidad",
    cart: "Tu Carrito",
    subtotal: "Subtotal",
    tax: "Impuesto",
    total: "Total",
    continueToReview: "Continuar a Revision",
    reviewAndConfirm: "Revisar y Confirmar",
    tradingSystem: "Sistema de Trading",
    selectTradingSystem: "Por favor selecciona un feed de datos",
    couponDiscount: "Descuento de Cupon",
    invalidCoupon: "El codigo de cupon ingresado no existe o ya ha expirado.",
    loadingQuote: "Cargando detalles del precio...",
    retry: "Reintentar",
    useWalletBalance: "Usar Saldo de Wallet",
    walletBalanceAvailable: "Disponible: {symbol}{amount}",
    walletCoversFullAmount: "Wallet cubre el monto total - no se necesita pago externo",
    walletPartialCover: "Los {symbol}{amount} restantes se cobraran via {method}",
    walletApplied: "Credito de Wallet",
    remainingAmount: "Monto Restante",
    volumeDiscount: "Descuento por Volumen",
    volumeDiscountSavings: "Ahorras {symbol}{amount} por unidad",
    volumeDiscountApplied: "Descuento por volumen aplicado ({percentage}% de descuento)",
    blacklistedTitle: "Compra No Disponible",
    blacklistedMessage: "Actualmente no estas autorizado para comprar nuevas evaluaciones. Por favor contacta a nuestro equipo de soporte para mas detalles."
  },
  contactModal: {
    title: "Contactanos",
    subtitle: "Estamos aqui para ayudarte a tener exito",
    messageSentTitle: "Mensaje Enviado Exitosamente!",
    messageSentDescription: "Gracias por contactarnos. Nuestro equipo te respondera dentro de 24 horas.",
    exploreWhileWaiting: "Mientras tanto, no dudes en explorar las funciones de nuestra plataforma o consultar nuestro proceso de evaluacion.",
    firstName: "Nombre",
    enterFirstName: "Ingresa tu nombre",
    lastName: "Apellido",
    enterLastName: "Ingresa tu apellido",
    emailAddress: "Correo Electronico",
    enterEmail: "Ingresa tu correo",
    accountNumber: "Numero de Cuenta",
    accountNumberPlaceholder: "Tu numero de cuenta (opcional)",
    subject: "Asunto",
    selectSubject: "Selecciona un asunto",
    generalInquiry: "Consulta General",
    evaluationProcess: "Proceso de Evaluacion",
    platformSupport: "Soporte de Plataforma",
    fundingQuestions: "Preguntas sobre Financiacion",
    technicalSupport: "Soporte Tecnico",
    partnership: "Alianza",
    message: "Mensaje",
    messagePlaceholder: "Cuentanos como podemos ayudarte...",
    otherWaysTitle: "Otras Formas de Contactarnos",
    businessHours: "Horario de Atencion",
    businessHoursTime: "Lun-Vie: 8:00 AM - 8:00 PM GST",
    sendingMessage: "Enviando Mensaje...",
    sendMessage: "Enviar Mensaje",
    errorSending: "Error al enviar el mensaje. Por favor intenta de nuevo.",
    overlayTitle: "Contáctenos por correo electrónico",
    overlayDescription: "Para cualquier pregunta, consulta o si necesita asistencia, escríbanos directamente a:",
    overlayButton: "Enviar correo"
  },
  partnershipModal: {
    title: "Alianzas Estrategicas",
    subtitle: "Oportunidades de Colaboracion Exclusivas",
    tabs: {
      overview: "Resumen",
      brandAmbassador: "Embajador de Marca",
      exclusiveContracts: "Contratos Exclusivos"
    },
    overview: {
      heroTitle: "Conviertete en nuestro",
      heroTitleHighlight: "Socio",
      heroTitleEnd: "y crece con nosotros",
      heroDescription: "Descubre nuestros programas de alianza adaptados a tus necesidades, ya seas un influencer o un negocio establecido.",
      brandAmbassador: {
        title: "Embajador de Marca",
        subtitle: "Programa para Creadores de Contenido",
        description: "Perfecto para influencers, educadores y creadores de contenido que quieren presentar nuestra plataforma a su audiencia.",
        benefits: {
          customCodes: "Codigos de referido personalizados y seguimiento",
          exclusiveContent: "Acceso a contenido de marketing exclusivo",
          prioritySupport: "Soporte al cliente prioritario",
          marketingCollaboration: "Oportunidades de colaboracion de marketing directo"
        }
      },
      exclusiveContracts: {
        title: "Contratos Exclusivos",
        subtitle: "Alianzas Corporativas",
        description: "Acuerdos personalizados para negocios establecidos, firmas de trading y profesionales de la industria que buscan una colaboracion mas profunda.",
        benefits: {
          customProfitSplits: "Acuerdos de reparto de ganancias negociados",
          dedicatedManager: "Gerente de cuenta dedicado y equipo de soporte",
          whiteLabelSolutions: "Opciones de plataforma y marca White Label",
          revenueSharingModels: "Modelos avanzados de reparto de ingresos y alianza"
        }
      },
      keyBenefits: {
        title: "Beneficios Clave de Nuestras Alianzas",
        higherCommissions: {
          title: "Mayores Comisiones",
          description: "Beneficiate de tasas de comision lideres en la industria y estructuras de bonos."
        },
        dedicatedSupport: {
          title: "Soporte Dedicado",
          description: "Recibe soporte personalizado de nuestro equipo de gestion de socios."
        },
        globalReach: {
          title: "Alcance Global",
          description: "Expande tu marca con nuestra presencia internacional."
        }
      }
    },
    brandAmbassador: {
      heroTitle: "Conviertete en nuestro",
      heroTitleHighlight: "Embajador de Marca",
      heroDescription: "Como embajador de marca, representas a Nextproptrader y te beneficias de ventajas y comisiones exclusivas.",
      requirements: {
        title: "Requisitos para Embajador de Marca",
        audienceSize: {
          title: "Audiencia Comprometida",
          description: "Prueba de una presencia en linea activa y comprometida."
        },
        contentQuality: {
          title: "Contenido de Alta Calidad",
          description: "Creacion de contenido relevante y atractivo para traders."
        },
        engagementRate: {
          title: "Alta Tasa de Interaccion",
          description: "Fuerte interaccion con tu comunidad."
        },
        brandAlignment: {
          title: "Alineacion de Marca",
          description: "Tus valores se alinean con los de Nextproptrader."
        }
      },
      exclusiveBenefits: {
        title: "Beneficios Exclusivos",
        customReferralCodes: {
          title: "Codigos de Referido Personalizados",
          description: "Codigos personalizados para tu audiencia."
        },
        exclusiveContent: {
          title: "Contenido de Marketing Exclusivo",
          description: "Acceso a banners, videos y textos especiales."
        },
        marketingMaterials: {
          title: "Materiales de Marketing Completos",
          description: "Recursos profesionales para apoyar tu promocion."
        },
        directCommunication: {
          title: "Comunicacion Directa",
          description: "Linea directa con nuestro equipo de gestion de socios."
        }
      }
    },
    exclusiveContracts: {
      heroTitle: "para",
      heroTitleHighlight: "Contratos Exclusivos",
      heroDescription: "Alianzas personalizadas para negocios y lideres de la industria que buscan una integracion y colaboracion mas profunda.",
      professionals: {
        title: "Traders Profesionales",
        subtitle: "Acuerdos Individuales",
        description: "Para traders experimentados que quieren operar con nuestro capital y beneficiarse de condiciones personalizadas.",
        benefits: {
          customProfitSplit: "Reparto de ganancias personalizado",
          accessToAlgorithms: "Acceso a algoritmos propietarios",
          tradeWithTeam: "Opera con nuestro equipo",
          profitFromCapital: "Beneficiate de nuestro capital"
        }
      },
      industryLeaders: {
        title: "Lideres de la Industria",
        subtitle: "Alianzas Estrategicas",
        description: "Para empresas que buscan una solucion white-label o una alianza estrategica mas profunda.",
        benefits: {
          revenueSharing: "Modelos de reparto de ingresos",
          whiteLabelOptions: "Opciones White Label",
          coMarketingOpportunities: "Oportunidades de co-marketing",
          customBrandingSolutions: "Soluciones de marca personalizadas"
        }
      }
    },
    contact: {
      title: "Interesado en una Alianza?",
      description: "Contactanos para saber mas sobre nuestros programas de alianza personalizados y como podemos crecer juntos.",
      button: "Contactanos"
    }
  },
  affiliateModal: {
    title: "Programa de Affiliate",
    subtitle: "Gana comisiones refiriendo traders",
    tabs: {
      overview: "Resumen",
      benefits: "Beneficios",
      requirements: "Requisitos"
    },
    overview: {
      heroTitle: "Gana",
      heroTitleHighlight: "10% de Comision",
      heroTitleEnd: "en Cada Referido",
      heroDescription: "Unete a nuestro programa de affiliate y gana comisiones generosas por cada trader que refieras a Nextproptrader.",
      features: {
        highCommissions: {
          title: "Altas Comisiones",
          subtitle: "Tasas lideres en la industria",
          description: "Gana 10% de comision en cada referido exitoso con potencial para tasas mas altas basadas en rendimiento."
        },
        customerDiscounts: {
          title: "Descuentos para Clientes",
          subtitle: "Valor para tu audiencia",
          description: "Tus referidos obtienen descuentos exclusivos, facilitando la conversion y proporcionando valor real a tu audiencia."
        }
      },
      commissionCalculator: {
        title: "Calculadora de Comisiones",
        sales: "ventas",
        proPlan: "Plan Pro prom.",
        mixedPlans: "Planes mixtos",
        averagePlan: "Plan promedio",
        monthlyGoal: "Objetivo mensual"
      },
      partnershipRewards: {
        title: "Recompensas de Alianza a Largo Plazo",
        description: "Construye un flujo de ingresos sostenible con nuestro programa de exito compartido de traders.",
        features: {
          traderSuccess: {
            title: "Bono por Exito del Trader",
            description: "Gana recompensas adicionales cuando tus referidos se vuelven rentables"
          },
          partnership: {
            title: "Niveles de Alianza",
            description: "Desbloquea tasas de comision mas altas y beneficios exclusivos"
          },
          passiveIncome: {
            title: "Ingresos Pasivos",
            description: "Sigue ganando de traders exitosos a largo plazo"
          }
        },
        premiumBenefits: {
          title: "Beneficios Premium de Alianza",
          description: "Los mejores affiliates obtienen acceso a oportunidades de alianza exclusivas, paginas de aterrizaje personalizadas y colaboracion directa con nuestro equipo de marketing."
        }
      }
    },
    benefits: {
      highConversion: {
        title: "Altas Tasas de Conversion",
        description: "Nuestro transparente 100% de reparto de ganancias y plataforma profesional convierten excepcionalmente bien."
      },
      premiumBrand: {
        title: "Marca Premium",
        description: "Promueve una firma de prop trading respetada y profesional con excelente reputacion."
      },
      bonusPayments: {
        title: "Bonos de Rendimiento",
        description: "Gana bonos adicionales basados en el exito a largo plazo de tus referidos."
      },
      marketingSupport: {
        title: "Soporte de Marketing",
        description: "Accede a materiales de marketing profesionales, banners y contenido promocional."
      },
      realTimeTracking: {
        title: "Seguimiento en Tiempo Real",
        description: "Monitorea tus referidos, comisiones y rendimiento con analiticas detalladas."
      },
      customerBenefits: {
        title: "Beneficios para Clientes",
        description: "Tus referidos reciben descuentos exclusivos y ofertas especiales a traves de tus enlaces."
      },
      payoutInfo: {
        title: "Informacion de Pagos",
        frequency: {
          value: "Mensual",
          label: "Frecuencia de Pago"
        },
        minimum: {
          value: "€50",
          label: "Pago Minimo"
        },
        methods: {
          value: "Multiples",
          label: "Metodos de Pago"
        }
      }
    },
    requirements: {
      title: "Requisitos para Unirse",
      nptAccount: {
        subtitle: "Cuenta requerida",
        description: "Necesitas una cuenta de Nextproptrader, que puedes crear iniciando una evaluacion o usando el boton de registro a continuacion."
      },
      marketingCompliance: {
        title: "Cumplimiento de Marketing",
        description: "Todas las actividades promocionales deben cumplir con nuestras directrices de marketing y las regulaciones aplicables."
      },
      existingAccountInfo: "Si ya tienes una cuenta de Nextproptrader, no necesitas registrarte de nuevo. Puedes usar tu cuenta existente para el programa de affiliate tambien - simplemente inicia sesion y navega a la pagina de Affiliate en el menu.",
      readyToJoin: {
        title: "Listo para Unirte a Nuestro Programa de Affiliate?",
        description: "Comienza a ganar comisiones hoy refiriendo traders a Nextproptrader.",
        loginButton: "Iniciar Sesion",
        createAccountButton: "Crear Cuenta"
      },
      register: {
        title: "Crear Cuenta",
        firstnameLabel: "Nombre",
        firstnamePlaceholder: "Juan",
        lastnameLabel: "Apellido",
        lastnamePlaceholder: "Perez",
        emailLabel: "Correo electronico",
        emailPlaceholder: "tu@correo.com",
        passwordLabel: "Contrasena",
        passwordPlaceholder: "Elige una contrasena segura",
        confirmPasswordLabel: "Confirmar contrasena",
        confirmPasswordPlaceholder: "Ingresa la contrasena de nuevo",
        passwordMismatch: "Las contrasenas no coinciden.",
        submitButton: "Crear Cuenta",
        submitting: "Creando...",
        successTitle: "Cuenta verificada exitosamente!",
        successDescription: "Tu correo ha sido verificado y tu cuenta esta activa. Puedes iniciar sesion y navegar a la pagina de Affiliate en el panel.",
        genericError: "Ocurrio un error. Por favor intenta de nuevo.",
        verifyTitle: "Verifica tu correo",
        verifyDescription: "Hemos enviado un correo de verificacion a tu direccion. Por favor ingresa el codigo del correo o haz clic en el enlace del correo para verificar tu cuenta.",
        codeLabel: "Codigo de verificacion",
        codePlaceholder: "123456",
        codeRequired: "Por favor ingresa el codigo de verificacion.",
        verifyButton: "Verificar",
        verifying: "Verificando...",
        verifyError: "La verificacion fallo. Por favor verifica tu codigo e intenta de nuevo.",
        verifyHint: "No recibiste un correo? Revisa tu carpeta de spam o regresa para registrarte de nuevo."
      }
    }
  },
  verifyRegistration: {
    title: "Verificar Registro",
    subtitle: "Verificacion de Cuenta",
    verifying: "Verificando tu cuenta...",
    success: "Tu cuenta ha sido verificada!",
    successDetail: "Tu correo ha sido confirmado y tu cuenta esta activa. Puedes iniciar sesion y comenzar a usar Nextproptrader.",
    error: "La verificacion fallo. El enlace puede ser invalido o haber expirado.",
    tryCode: "Ingresar codigo de verificacion manualmente",
    codeTitle: "Ingresar Codigo de Verificacion",
    codeDescription: "Ingresa el codigo de verificacion del correo que te enviamos para completar tu registro.",
    emailLabel: "Correo electronico",
    emailPlaceholder: "tu@correo.com",
    codeLabel: "Codigo de verificacion",
    codePlaceholder: "123456",
    allFieldsRequired: "Por favor completa todos los campos.",
    verifyButton: "Verificar Cuenta",
    verifyingButton: "Verificando...",
    backToHome: "Volver a la Pagina Principal"
  },
  verifyPayment: {
    subtitle: "Verificacion de Pago",
    verifying: "Verificando tu pago...",
    verifyingDetail: "Estamos verificando el estado de tu pago. Esto puede tomar unos momentos.",
    success: "Pago exitoso!",
    successDetail: "Tu pago ha sido confirmado. Tu cuenta esta siendo configurada y estara disponible en breve.",
    failed: "Pago fallido",
    failedDetail: "Tu pago no pudo ser procesado. Por favor intenta de nuevo o contacta al soporte si el problema persiste.",
    expired: "Enlace de pago expirado",
    expiredDetail: "Este enlace de pago ha expirado. Por favor inicia un nuevo proceso de pago para completar tu compra.",
    timeout: "La verificacion esta tomando mas tiempo de lo esperado",
    timeoutDetail: "Tu pago puede estar aun en proceso. Puedes intentar de nuevo o revisar tu correo para una confirmacion.",
    retry: "Verificar de nuevo",
    backToHome: "Volver a la Pagina Principal",
    closeTab: "Cerrar Pestana"
  },
  whiteLabelModal: {
    title: "Solucion White Label",
    subtitle: "Infraestructura y plataforma tecnologica completa",
    heroTitle: "Lanza Tu Propia Firma de Prop Trading",
    heroDescription: "Obtiene una plataforma de prop trading completamente personalizada y lista para usar bajo tu propio nombre. Nuestra solucion White Label proporciona todo lo que necesitas para operar un negocio profesional de prop trading, desde la evaluacion de traders hasta la gestion de cuentas financiadas.",
    features: {
      customBranding: {
        title: "Marca Personalizada",
        description: "Personalizacion completa de marca incluyendo logo, colores, fuentes y elementos de diseno para coincidir con tu identidad corporativa."
      },
      ownDomain: {
        title: "Tu Propio Dominio",
        description: "Ejecuta tu plataforma en tu propio dominio con certificados SSL personalizados para una experiencia profesional y fluida."
      },
      fullControl: {
        title: "Control Total",
        description: "Gestiona traders, cuentas, pagos y reglas de forma independiente con un potente panel de administracion."
      },
      cloudHosting: {
        title: "Hosting en la Nube",
        description: "Infraestructura en la nube de nivel empresarial con CDN global, escalado automatico y garantia de disponibilidad del 99.9%."
      },
      apiAccess: {
        title: "Acceso API",
        description: "API REST completa para integracion fluida con tus sistemas existentes y servicios de terceros."
      },
      customization: {
        title: "Personalizacion Flexible",
        description: "Configura reglas de evaluacion, repartos de ganancias, tamanos de cuenta y parametros de trading para adaptarse a tu modelo de negocio."
      }
    },
    whyChoose: {
      title: "Por que White Label?",
      setup: {
        value: "< 2 Semanas",
        label: "Tiempo de Configuracion"
      },
      uptime: {
        value: "99.9%",
        label: "Garantia de Disponibilidad"
      },
      support: {
        value: "24/7",
        label: "Soporte Tecnico"
      }
    },
    contact: {
      title: "Listo para Lanzar Tu Solucion White Label?",
      description: "Contacta a nuestro equipo para discutir tus requisitos de White Label y obtener una solucion personalizada adaptada a las necesidades de tu negocio.",
      button: "Contactar al Equipo White Label"
    }
  },
  affiliateStatus: {
    enroll: {
      title: "Unete al Programa de Affiliate",
      subtitle: "Conviertete en Socio de Nextproptrader",
      description: "Si deseas participar en el programa de affiliate de Nextproptrader, puedes registrarte facilmente aqui. Al inscribirte, confirmas que has leido y aceptas nuestros terminos de servicio, politica de privacidad y directrices de affiliate - la participacion solo es posible despues de la aceptacion.",
      benefits: "Como affiliate, tendras acceso a un potente panel de socios con seguimiento completo (clics, leads, ventas en tiempo real), enlaces de affiliate individuales y la capacidad de crear tus propios codigos de cupon. Te beneficias de comisiones generosas, pagos de bonos opcionales y opciones de pago flexibles - incluyendo transferencia bancaria, PayPal o cripto (dependiendo de la disponibilidad/opcion en el sistema).",
      button: "Registrarse Ahora",
      enrolling: "Registrando...",
      trackingTitle: "Seguimiento en Tiempo Real",
      trackingDesc: "Rastrea clics, leads y ventas en vivo",
      linksTitle: "Enlaces Personalizados",
      linksDesc: "Enlaces de affiliate individuales y codigos de cupon",
      commissionsTitle: "Comisiones",
      commissionsDesc: "Compensacion generosa y pagos de bonos",
      payoutsTitle: "Pagos Flexibles",
      payoutsDesc: "Banco, PayPal o Cripto"
    },
    suspended: {
      title: "Cuenta Suspendida",
      description: "Tu cuenta de affiliate ha sido suspendida. Ya no tienes acceso al programa de affiliate.",
      support: "Si crees que esto es un error o deseas mas informacion, por favor contacta a nuestro equipo de soporte para aclaracion.",
      contactSupport: "Contactar Soporte"
    },
    pending: {
      title: "Completar Registro de Affiliate",
      subtitle: "Acepta los terminos y configura tu perfil de socio",
      step1: "Aceptar Terminos",
      step2: "Nombre de Socio",
      loading: "Cargando Acuerdos",
      loadingDescription: "Preparando tu registro de affiliate...",
      termsTitle: "Terminos y Condiciones del Programa de Affiliate",
      acceptTerms: "He leido y acepto los Terminos y Condiciones del Programa de Affiliate",
      continue: "Continuar al Paso 2",
      nameTitle: "Establece Tu Nombre de Socio",
      nameDescription: "Elige un nombre para mostrar que aparecera en tus materiales y reportes de affiliate",
      partnerName: "Nombre para Mostrar del Socio",
      partnerNamePlaceholder: "Ingresa tu nombre de socio...",
      back: "Atras",
      complete: "Completar Registro",
      submitting: "Completando..."
    },
    complete: {
      title: "Registro Completado",
      description: "Tu cuenta de affiliate esta siendo activada. Esta pagina se actualizara automaticamente."
    }
  },
  months: {
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre"
  },
  partnerLanding: {
    backToMainSite: "Volver al Sitio Principal",
    officialPartner: "Socio Oficial",
    heroDescription: "Obtiene acceso exclusivo al prop trading profesional con beneficios especiales de socio. Comienza tu camino de trading financiado con",
    profitSplit: "100% de reparto de ganancias",
    noHiddenFees: "y sin costos ocultos.",
    benefits: {
      exclusiveDiscounts: {
        title: "Descuentos Exclusivos",
        description: "Precios especiales solo disponibles a traves de {partner}"
      },
      profitSplit: {
        title: "100% Reparto de Ganancias",
        description: "Quedate con todo lo que ganas - sin recortes ocultos"
      },
      premiumSupport: {
        title: "Soporte Premium",
        description: "Soporte prioritario como referido de socio"
      }
    },
    startEvaluation: "Comienza Tu Evaluacion",
    whyChoose: "Por Que Elegir",
    whyChooseBadge: "Nuestras Ventajas",
    recommendedBy: "Recomendado por {partner} para traders serios que quieren resultados reales",
    features: {
      profitSplit: {
        title: "100% Reparto de Ganancias",
        description: "Quedate con todo lo que ganas. Sin recortes ni comisiones ocultas."
      },
      dailyPayouts: {
        title: "Pagos Diarios",
        description: "Accede a tus ganancias inmediatamente, no semanas despues."
      },
      transparentRules: {
        title: "Reglas Transparentes",
        description: "Reglas claras y justas sin restricciones sorpresa."
      },
      noTimePressure: {
        title: "Sin Presion de Tiempo",
        description: "Opera a tu propio ritmo - sin dias minimos de trading requeridos."
      }
    },
    pricing: {
      exclusiveBadge: "PRECIOS EXCLUSIVOS DE SOCIO",
      title: "Tarifas Especiales para la",
      community: "Comunidad",
      description: "Obtiene descuentos exclusivos y comienza a operar con nuestro capital hoy. Oferta por tiempo limitado!"
    },
    testimonial: {
      title: "Confiado por",
      quote: "{partner} ha seleccionado cuidadosamente a Nextproptrader como la firma de prop trading preferida para nuestra comunidad. Con su 100% de reparto de ganancias y enfoque transparente, se alinean perfectamente con nuestros valores de ayudar a los traders a tener exito.",
      stats: {
        profitSplit: "Reparto de Ganancias",
        daily: "Diario",
        payouts: "Pagos",
        oneDay: "5 Dias",
        minEvaluation: "Min. Evaluacion"
      }
    },
    howItWorks: {
      badge: "Como Funciona",
      title: "Como",
      titleHighlight: "Funciona",
      subtitle: "Proceso simple de 3 pasos para obtener financiacion y comenzar a ganar",
      steps: {
        step1: {
          title: "Elige Tu Plan",
          description: "Selecciona el tamano de cuenta que se adapte a tu estilo de trading y obtiene descuentos exclusivos de socio."
        },
        step2: {
          title: "Aprueba la Evaluacion",
          description: "Alcanza tu objetivo de ganancia mientras gestionas el riesgo adecuadamente - sin presion de tiempo."
        },
        step3: {
          title: "Obtiene Financiacion y Cobra",
          description: "Recibe tu cuenta financiada y comienza a ganar con 100% de reparto de ganancias y pagos diarios."
        }
      }
    },
    finalCta: {
      title: "Listo para Comenzar a Operar con",
      titleHighlight: "Nuestro Capital?",
      description: "Unete a miles de traders exitosos que confian en Nextproptrader. Comienza hoy con los precios exclusivos de {partner}.",
      viewPricing: "Ver Precios de Socio",
      learnMore: "Saber Mas Sobre Nextproptrader"
    }
  },
  kyc: {
    title: "Verificacion de Identidad",
    subtitle: "Verificacion KYC",
    introTitle: "Verifica tu identidad",
    introDescription: "Antes de poder solicitar un retiro, necesitamos verificar tu identidad. Este es un proceso unico requerido por los estandares regulatorios para garantizar la seguridad de tu cuenta y tus fondos.",
    introStep1: "Proporciona tu fecha de nacimiento",
    introStep2: "Confirma tu nacionalidad y pais de residencia",
    introStep3: "Sube un documento de identidad oficial valido",
    introNote: "Tus datos estan encriptados y almacenados de forma segura. Solo los utilizamos con fines de verificacion de acuerdo con las regulaciones aplicables.",
    startVerification: "Iniciar verificacion",
    stepPersonal: "Datos personales",
    stepDocument: "Documento",
    stepReview: "Revision",
    personalInfoTitle: "Informacion personal",
    personalInfoDesc: "Proporciona tus datos personales exactamente como aparecen en tu documento de identidad oficial.",
    dateOfBirth: "Fecha de nacimiento",
    nationality: "Nacionalidad",
    residenceCountry: "Pais de residencia",
    searchCountry: "Buscar pais...",
    continue: "Continuar",
    documentTitle: "Documento de identidad",
    documentDesc: "Sube una foto clara o escaneo de tu documento de identidad oficial emitido por el gobierno.",
    acceptedDocuments: "Documentos aceptados",
    docPassport: "Pasaporte valido",
    docIdCard: "Documento nacional de identidad",
    docRequirements: "JPG, PNG, WebP o PDF. Max 10 MB. Asegurate de que el documento sea claramente visible y todos los detalles sean legibles.",
    dragOrClick: "Haz clic para subir o arrastra y suelta",
    supportedFormats: "JPG, PNG, WebP, PDF - max 10 MB",
    clickToChange: "Haz clic para cambiar el archivo",
    uploadDocument: "Subir y continuar",
    back: "Atras",
    reviewTitle: "Revisa tu informacion",
    reviewDesc: "Verifica que toda la informacion sea correcta antes de enviar.",
    documentUploaded: "Documento",
    documentReady: "Documento subido",
    reviewWarning: "Asegurate de que toda la informacion coincida exactamente con tus documentos oficiales. La informacion incorrecta puede retrasar el proceso de verificacion.",
    submitVerification: "Enviar verificacion",
    successTitle: "Verificacion enviada",
    successDescription: "Tu verificacion de identidad ha sido enviada exitosamente. Nuestro equipo revisara tus documentos y seras notificado una vez que el proceso se complete.",
    processingTime: "Tiempo de procesamiento: hasta 48 horas",
    pendingTitle: "Verificacion en progreso",
    pendingDescription: "Tu verificacion de identidad esta siendo revisada actualmente por nuestro equipo. Seras notificado una vez que la revision se complete. Esto generalmente toma hasta 48 horas.",
    close: "Cerrar",
    errorStarting: "No se pudo iniciar la verificacion. Por favor, intentalo de nuevo.",
    errorSaving: "No se pudo guardar tu informacion. Por favor, intentalo de nuevo.",
    errorSubmitting: "No se pudo enviar la verificacion. Por favor, intentalo de nuevo.",
    uploadFailed: "No se pudo subir el documento. Por favor, intentalo de nuevo.",
    invalidFileType: "Tipo de archivo no valido. Sube un archivo JPG, PNG, WebP o PDF.",
    fileTooLarge: "El archivo es demasiado grande. El tamano maximo es 10 MB.",
    rejectedTitle: "Verificacion rechazada",
    rejectedDescription: "Lamentablemente, tu verificacion de identidad ha sido rechazada. Revisa el motivo a continuacion y reinicia el proceso con informacion correcta.",
    rejectionReasonLabel: "Motivo del rechazo",
    rejectedHint: "Puedes reiniciar el proceso de verificacion. Asegurate de que toda la informacion sea correcta y que tus documentos sean claramente legibles.",
    restartVerification: "Reiniciar verificacion"
  },
  countdown: {
    comingSoon: "Proximamente",
    liveNow: "Estamos En Linea",
    description: "Algo grande esta en camino. Preparate para una nueva era del prop trading.",
    liveDescription: "La espera ha terminado. Bienvenido al futuro del prop trading.",
    days: "Dias",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
    launchDate: "1 de abril de 2026 - 08:00 UTC",
    enterCode: "Codigo de acceso..."
  },
  affiliatePage: {
    nav: {
      home: "Inicio",
      apply: "Solicitar gratis"
    },
    hero: {
      badge: "PROGRAMA DE AFILIADOS NEXTPROPTRADER",
      headline: "Gana con cada trader que recomiendas.",
      subline: "Conviértete en socio afiliado de Nextproptrader y construye un ingreso escalable con un producto sólido, comisiones atractivas y niveles de bonificación.",
      cta1: "Solicitar gratis",
      cta2: "Calcula tu potencial de afiliado",
      trust1: "25% Comisión de afiliado",
      trust2: "Mejores condiciones",
      trust3: "100% Payout para tu comunidad",
      trust4: "Bonos únicos",
      dashboardTitle: "Panel de Afiliados",
      dashboardLive: "En vivo",
      dashboardClicks: "Clics",
      dashboardOrders: "Pedidos",
      dashboardConversion: "Conversión",
      dashboardCommission: "Comisión total",
      dashboardTier: "Nivel actual",
      dashboardRecentSales: "Ventas recientes"
    },
    stats: {
      funded: "Capital financiado",
      traders: "Traders activos",
      commission: "Comisión de afiliado",
      bonus: "Bono único posible"
    },
    why: {
      headline: "¿Por qué promover Nextproptrader?",
      cards: [
        {
          title: "Un producto que convence a los traders",
          text: "Nextproptrader ofrece 100% de reparto de ganancias, pagos diarios y evaluaciones justas — una propuesta que destaca en el sector."
        },
        {
          title: "Estructura de comisiones competitiva",
          text: "Empieza en el 10% y llega hasta el 25% de comisión por venta. Cada referido genera ingresos directos — sin límites de volumen."
        },
        {
          title: "Bonos únicos en hitos clave",
          text: "Alcanzar hitos clave desbloquea bonos únicos en efectivo — hasta €10.000 por nivel."
        },
        {
          title: "Panel en tiempo real transparente",
          text: "Rastrea clics, conversiones y comisiones en tiempo real. Visibilidad completa de tu rendimiento — en cualquier momento y lugar."
        }
      ]
    },
    tiers: {
      headline: "Tu camino. Tu comisión.",
      subline: "Empieza como afiliado y avanza paso a paso hacia niveles de comisión más altos.",
      commissionLabel: "Comisión",
      bonusLabel: "Bono único",
      salesLabel: "desde ventas",
      overviewLabel: "Resumen de niveles",
      startLevel: "Nivel inicial",
      fromSales: "desde {n} ventas",
      tierOf: "Nivel {current} / {total}",
      noMinimum: "Sin mínimo",
      noMinRevenue: "Sin facturación mínima",
      confirmedSales: "Desde {n} ventas confirmadas",
      maxCommission: "Comisión máx.",
      descriptions: {
        starter: "Perfecto para empezar. Comienza sin requisitos mínimos y gana de inmediato con tus primeras recomendaciones. Sin solicitud, sin ingresos mínimos.",
        bronze: "Tu primer hito. Con 50 ventas exitosas desbloqueas un bono único y demuestras que tu audiencia convierte.",
        silber: "Rendimiento sólido. A 150 ventas tu bono crece a €2.500 — una señal clara de que tu canal genera valor real.",
        gold: "Mayor comisión. A partir de 300 ventas tu comisión sube al 15% — más ganancias en las mismas recomendaciones, automáticamente.",
        platin: "Gran alcance. 500 ventas significan un modelo de referidos probado — recompensado con un bono único de €5.000.",
        diamant: "Alto rendimiento. Has construido una máquina de afiliación escalable. Tu bono único: €10.000.",
        elite: "Estado élite. Solo los afiliados más fuertes alcanzan este nivel — con un 25% de comisión por venta y potencial ilimitado."
      }
    },
    calc: {
      headline: "Calcula tu potencial de afiliado",
      subline: "Obtén una estimación aproximada de cuánta comisión podría generar tu alcance.",
      disclaimer: "Este cálculo es solo una estimación y se basa en suposiciones sobre la tasa de conversión y el valor promedio del pedido.",
      followerLabel: "Tus suscriptores / seguidores",
      conversionLabel: "Tasa de conversión estimada",
      salesOutput: "Ventas estimadas",
      revenueOutput: "Ingresos estimados",
      commissionOutput: "Comisión estimada",
      tierOutput: "Nivel actual",
      progressLabel: "Ventas hasta el siguiente nivel",
      bonusNote: "Alcanzar este nivel también incluye un bono único de",
      bonusNote2: "",
      cta: "Solicitar gratis",
      basisLabel: "Base de cálculo",
      estimatedBuyers: "Compradores estimados",
      avgOrderValue: "Valor medio del pedido",
      commissionShort: "Comisión",
      perMonthEstimate: "por mes (estimación)",
      footerNote: "Estimación basada en promedios históricos. Los resultados individuales pueden variar.",
      eliteReached: "Estado élite alcanzado",
      eliteMax: "Comisión máxima del 25%"
    },
    steps: {
      headline: "Cómo funciona",
      items: [
        {
          title: "Regístrate gratis",
          text: "Solicita el programa de afiliados y obtén acceso inmediato a tu enlace de seguimiento personal tras la aprobación."
        },
        {
          title: "Comparte tu enlace de afiliado",
          text: "Integra tu enlace en videos, newsletters, publicaciones en redes sociales o tu sitio web — llega a tu audiencia donde está activa."
        },
        {
          title: "Gana comisiones",
          text: "Por cada compra a través de tu enlace, recibes tu comisión. A medida que creces, avanzas automáticamente a niveles superiores."
        }
      ]
    },
    faq: {
      headline: "Preguntas frecuentes",
      items: [
        {
          q: "¿Cuánto es la comisión?",
          a: "La comisión comienza en el 10% (nivel Starter) y puede llegar al 25% (nivel Elite) con el crecimiento del rendimiento. Ciertos niveles también incluyen bonos únicos de hasta €10.000."
        },
        {
          q: "¿Cuándo me pagan?",
          a: "Los detalles exactos de pago se comunican durante el proceso de incorporación. Estamos construyendo un proceso de pago transparente y confiable para todos los socios afiliados."
        },
        {
          q: "¿Hay requisitos mínimos?",
          a: "No hay requisitos mínimos de seguidores ni umbrales de ingresos para aplicar. Cualquier persona con una audiencia relevante en trading o finanzas puede aplicar."
        },
        {
          q: "¿Cuánto dura el cookie?",
          a: "La duración de la cookie de seguimiento se comunica dentro del panel de afiliados. Una ventana de cookie más larga generalmente permite tasas de conversión más altas."
        },
        {
          q: "¿Puedo crear múltiples enlaces?",
          a: "Sí. Dentro del panel de afiliados puedes crear múltiples enlaces de seguimiento para diferentes canales, campañas o contenidos, y hacer un seguimiento de su rendimiento por separado."
        }
      ]
    },
    cta: {
      headline: "¿Listo para crecer como afiliado de Nextproptrader?",
      subline: "Solicita gratis y asegura tu acceso al programa de afiliados.",
      button: "Solicitar gratis",
      support: "Gratis. Sin compromiso. Inicio rápido."
    },
    footer: {
      copy: "© 2024 Nextproptrader. Todos los derechos reservados.",
      program: "Programa de Afiliados"
    }
  }
};
